/* TrueSanity ring builder (setting → lab diamond → complete ring).
   Used by sections/ts2-setting.liquid (step 1) and sections/ts2-builder.liquid (steps 2-3).
   Choices are kept in localStorage "ts2_ring". Add to Bag uses the same ring service and cart
   properties as the old complete-ring page, so cart, checkout and orders keep working the same way. */
(function () {
  'use strict';
  var root = document.querySelector('[data-tsb]');
  if (!root) return;

  /* ---------- helpers ---------- */
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '$' + Math.round(c / 100).toLocaleString('en-US'); }
  function money2(c) { return '$' + (Math.round(c) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); }
  function metalKey(m) { return String(m || '').toLowerCase().replace(/\s+/g, ''); }
  function ct(n) { var x = parseFloat(n); return isNaN(x) ? '' : x.toFixed(2); }
  // rings and necklaces (pendants) share this builder; each keeps its own choices
  var KIND = root.getAttribute('data-kind') || 'ring';
  var PENDANT = KIND === 'pendant', EARRING = KIND === 'earring';
  // gemstone rings: the setting page can hand over to the gemstone builder (ts2-gem.js), which keeps its own choices
  var GEM = root.getAttribute('data-stone') === 'gemstone';
  var KEY_STATE = GEM ? 'ts2_gemring' : 'ts2_' + KIND;
  /* diamond type the shopper picked (settings page switch or the builder's diamond step): natural first.
     Shared by the settings list, the setting page and the diamond step of the ring builder. */
  var DT_KEY = 'ts2_dtype', NAT_RING = KIND === 'ring' && !GEM;
  var RING_MAX_CT = 50;   // ring settings: center diamonds up to this size
  function prefType() { var t = ''; try { t = localStorage.getItem(DT_KEY) || ''; } catch (e) {} return t === 'lab' || t === 'natural' ? t : 'natural'; }
  function setPrefType(t) { try { localStorage.setItem(DT_KEY, t); } catch (e) {} }
  var W = PENDANT
    ? { piece: 'necklace', Piece: 'Necklace', setting: 'pendant', Setting: 'Pendant', settings: 'pendants', size: 'chain length', Size: 'Chain length' }
    : EARRING
    ? { piece: 'earrings', Piece: 'Earrings', setting: 'setting', Setting: 'Setting', settings: 'settings', size: '', Size: '' }
    : { piece: 'ring', Piece: 'Ring', setting: 'setting', Setting: 'Setting', settings: 'settings', size: 'ring size', Size: 'Ring size' };
  // earrings: a matched pair of diamonds from the pairs service; photos have no shape in the name
  function colorWord(t) { t = String(t || '').toLowerCase(); return /platinum/.test(t) ? 'platinum' : /black/.test(t) ? 'black' : /rose/.test(t) ? 'rose' : /yellow/.test(t) ? 'yellow' : 'white'; }
  var WG = EARRING ? '14kwhitegold' : '18kwhitegold';
  function photoPre(sku, shape, tk, mk) {
    return EARRING ? 'dyoe_setting_' + String(sku).toLowerCase() + '_' + tk + '_' + mk + '-'
                   : 'dyor_setting_' + String(sku).toLowerCase() + '_' + String(shape).toLowerCase() + '_' + tk + '_' + mk + '-';
  }
  function load() { try { return JSON.parse(localStorage.getItem(KEY_STATE) || '{}') || {}; } catch (e) { return {}; } }
  function save(s) { try { localStorage.setItem(KEY_STATE, JSON.stringify(s)); } catch (e) {} }
  var state = load();
  var BUILDER = root.getAttribute('data-builder') || '/pages/build-your-ring';
  function bUrl(params) {
    var u = new URL(BUILDER, location.origin);
    Object.keys(params || {}).forEach(function (k) { if (params[k] != null) u.searchParams.set(k, params[k]); });
    return u.pathname + u.search;
  }
  var API = window.API_URL || 'https://truesanity.011101100110111001110011.net/api/';
  var KEY = 'TSANITY121A3VG7NEMVRXXEWGM';
  // natural diamonds: switched on in the theme editor (Ring builder section) once the natural feed works; ?ts2_natural=1 previews it
  // ?ts2_natural=1 previews it for the rest of the visit (the flag rides along as the shopper moves between steps); ?ts2_natural=0 ends it
  var NATURAL = root.getAttribute('data-natural') === 'true';
  if (!NATURAL) {
    try {
      if (/[?&]ts2_natural=1/.test(location.search)) sessionStorage.setItem('ts2_natural', '1');
      if (/[?&]ts2_natural=0/.test(location.search)) sessionStorage.removeItem('ts2_natural');
      NATURAL = sessionStorage.getItem('ts2_natural') === '1';
    } catch (e) { NATURAL = /[?&]ts2_natural=1/.test(location.search); }
  }
  /* natural: VDB inventory in TrueSanity's Supabase (edge function vdb-diamonds,
     synced every 3 hours by vdb-sync, priced with the "Loose natural diamond" protocol fee). Same body and fields. */
  var NAT_API = window.TS_NATURAL_API || 'https://tghmqkncwbxynkulevgw.supabase.co/functions/v1/vdb-diamonds';
  /* lab grown single diamonds (ring and pendant builders) also come from VDB in Supabase (?kind=lab, priced with the
     "Loose lab diamond" protocol fee). The earring builder (matched pairs and our own pairs) stays on the old service.
     Lab stones picked before the switch are passed through to the old service by vdb-diamonds. */
  var LAB_VDB = !EARRING;
  function feedUrl(type, path) {
    if (type === 'natural' || (type === 'lab' && LAB_VDB)) {
      var q = path.indexOf('?'), base = q < 0 ? path : path.slice(0, q), qs = q < 0 ? '' : path.slice(q + 1);
      return NAT_API + base + (type === 'lab' ? '?kind=lab' + (qs ? '&' + qs : '') : (qs ? '?' + qs : ''));
    }
    return API + (type === 'pair' ? 'diamonds/apiservices/dyoe/new_api' : 'diamonds/apiservices/new_api') + path;
  }
  function api(path, opts, type) {
    opts = opts || {};
    return fetch(feedUrl(type, path), {
      method: opts.method || 'GET', signal: opts.signal,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-API-Key': KEY },
      body: opts.body ? JSON.stringify(opts.body) : undefined
    }).then(function (r) { if (!r.ok) throw new Error('Diamond service ' + r.status); return r.json(); });
  }
  /* diamonds reserved by another shopper's bag (Supabase "holds", 30 min). Same browser holder id as the bag (assets/ts-cart.js),
     so a shopper never hides their own diamond. Fails open: if the service is down nothing is hidden. */
  var HOLDS = window.TS_HOLDS_URL || 'https://tghmqkncwbxynkulevgw.supabase.co/functions/v1/holds';
  function holderId() {
    var h = null; try { h = localStorage.getItem('tsc_holder'); } catch (e) {}
    if (!h) { h = 'h-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12); try { localStorage.setItem('tsc_holder', h); } catch (e) {} }
    return h;
  }
  // the feed ids behind a diamond or pair (our own matched pairs are "m<id1>-<id2>")
  function stoneIdsOf(d) {
    var m = /^m(\d+)-(\d+)$/.exec(String(d.id));
    return m ? [m[1], m[2]] : [d.id, d.id1].filter(Boolean).map(String);
  }
  function heldElsewhere(ids) {
    ids = (ids || []).filter(Boolean).map(String);
    if (!ids.length) return Promise.resolve({});
    return fetch(HOLDS, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ op: 'check', ids: ids, holder: holderId() }) })
      .then(function (r) { return r.json(); }).then(function (j) { var o = {}; (j.blocked || []).forEach(function (x) { o[x] = 1; }); return o; })
      .catch(function () { return {}; });
  }
  var imgCache = {};
  function imageList(pid) {
    if (!imgCache[pid]) imgCache[pid] = fetch('https://1yi00t63hl.execute-api.us-east-1.amazonaws.com/v1/' + pid)
      .then(function (r) { return r.json(); }).catch(function () { return []; });
    return imgCache[pid];
  }
  /* setting photos for a shape + metal: dyor_setting_<sku>_<shape>_1_<metal>-N.jpg, in N order */
  function settingFiles(list, sku, shape, metal, tk) {
    function pick(t, mk) {
      var pre = photoPre(sku, shape, t, mk);
      return list.filter(function (u) { return u.split('/').pop().toLowerCase().indexOf(pre) === 0; })
        .sort(function (a, b) { return (parseInt(a.split('-').pop(), 10) || 0) - (parseInt(b.split('-').pop(), 10) || 0); });
    }
    var mk = metalKey(metal), t = tk || '1', out = pick(t, mk);
    if (!out.length && /platinum/i.test(metal)) { mk = WG; out = pick(t, mk); }
    if (!out.length && t !== '1') { t = '1'; mk = metalKey(metal); out = pick(t, mk); if (!out.length && /platinum/i.test(metal)) { mk = WG; out = pick(t, mk); } }
    return { photos: out.filter(function (u) { return /\.(jpe?g|png|webp)$/i.test(u); }), video: out.filter(function (u) { return /\.mp4$/i.test(u); })[0] || '', tk: t, mk: mk };
  }
  function settingPhotos(list, sku, shape, metal) { return settingFiles(list, sku, shape, metal, '1').photos; }
  /* the rendered carat closest to a diamond's weight (file token: 1-2, 3-4, 1, 11-2, 2, 3, 4) */
  function nearestToken(carat) {
    if (carat > 4.5) return '1';   // large centers (Oct 30 2026): no render that big, the ring is shown with a 1 ct
    var opts = [[0.33, '1-3'], [0.5, '1-2'], [0.75, '3-4'], [1, '1'], [1.5, '11-2'], [2, '2'], [3, '3'], [4, '4']];
    return opts.reduce(function (a, b) { return Math.abs(b[0] - carat) < Math.abs(a[0] - carat) ? b : a; })[1];
  }
  /* 360 frames: /360/<pid>/<sku>_<shape>_<tk>_<metal>-4/frameNN.png; resolves the frame count (0 = none) */
  var spinCounts = {};
  function probeImg(u) { return new Promise(function (res) { var im = new Image(); im.onload = function () { res(true); }; im.onerror = function () { res(false); }; im.src = u; }); }
  function frameUrl(base, i) { return base + (i < 10 ? '0' + i : i) + '.png'; }
  function spinCount(base) {
    if (!spinCounts[base]) spinCounts[base] = probeImg(frameUrl(base, 1)).then(function (ok) {
      if (!ok) return 0;
      var lo = 1, hi = 181;
      function step() { if (hi - lo <= 1) return Promise.resolve(lo); var m = (lo + hi) >> 1; return probeImg(frameUrl(base, m)).then(function (y) { if (y) lo = m; else hi = m; return step(); }); }
      return step();
    });
    return spinCounts[base];
  }
  /* a slide that turns the ring by itself (and by drag) */
  function autoSpin(img) {
    var base = img.getAttribute('data-spin-base');
    spinCount(base).then(function (n) {
      if (!n) { var sl = img.closest('.ts2-slide'); if (sl) sl.remove(); return; }
      var frames = [], loaded = 0, i = 0, timer = null, x0 = null, i0 = 0;
      for (var k = 1; k <= n; k++) { var im = new Image(); im.onload = im.onerror = function () { if (++loaded === n) go(); }; im.src = frameUrl(base, k); frames.push(im.src); }
      function show(j) { i = (j % n + n) % n; img.src = frames[i]; }
      function go() { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, 70); }
      var host = img.parentElement;
      host.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; clearInterval(timer); x0 = e.clientX; i0 = i; });  // phones: swipe moves the gallery, the ring keeps turning by itself
      host.addEventListener('pointermove', function (e) { if (x0 != null) show(i0 - Math.round((e.clientX - x0) / (host.clientWidth / n * 1.4))); });
      host.addEventListener('pointerup', function () { x0 = null; });
    });
  }
  function isNat(d) { return d && d.type === 'natural'; }
  function kindWord(d) { return d && d.pair ? 'Lab grown pair' : isNat(d) ? 'Natural' : 'Lab grown'; }
  function diamondTitle(d) {
    if (d && d.pair) return ct(d.carat) + ' ct t.w. ' + cap(d.shape) + ' Lab Grown Diamond Pair';
    return ct(d.carat) + ' ct ' + cap(d.shape) + (isNat(d) ? ' Natural Diamond' : ' Lab Grown Diamond');
  }
  function dUrl(d) { var o = { did: d.id }; if (isNat(d)) o.dt = 'natural'; return bUrl(o); }
  function grades(d) { return [d.color, d.clarity, d.cut && d.cut !== '-' ? d.cut : ''].filter(Boolean).join(' · '); }
  /* normalise a diamond from the list or the single-diamond call */
  // diamonds hidden from the lists (wrong supplier photo etc.), set in the builder section's settings
  var HIDE_D = {}; String(root.getAttribute('data-hide-diamonds') || '').split(/[\s,]+/).forEach(function (x) { if (x) HIDE_D[x] = 1; });
  function notHidden(d) { return !d || !(HIDE_D[String(d.id)] || (d.id1 && HIDE_D[String(d.id1)])); }
  function normD(x) {
    return {
      id: x.diamond_id || x.Diamond_ID, shape: x.shape || x.Shape, carat: parseFloat(x.size || x.weight || x.Weight),
      color: x.color || x.Color, clarity: x.clarity || x.Clarity, cut: x.cut || x.Cut || '',
      polish: x.polish || x.Polish, symmetry: x.symmetry || x.Symmetry, fluor: x.fluor_intensity || x.Fluorescence_Intensity,
      table: x.table || x.Table_Percent, depth: x.depth || x.Depth_Percent, ratio: x.ratio || x.Ratio,
      meas: x.measurements || x.Measurements, lab: x.lab || x.Lab || 'IGI',
      cert: x.Certificate_Number || x.certificate_number || '', certUrl: x.Certificate_URL || '',
      img: x.image_url || x.Image_URL || '', v360: x.Column81 || '',
      price: Math.round(parseFloat(x.total_sales_price || x.Total_Price) * 100),
      cost: Math.round((parseFloat(x.rapent_price) || (parseFloat(x.Price_Per_Carat) * parseFloat(x.Weight || x.weight || x.size)) || 0) * 100),
      seller: x.Seller_Name || '', growth: x.Cert_Comments || '', inscription: x.Laser_Inscription || ''
    };
  }

  /* a matched pair (earrings): the pairs service gives each field twice, ending in 1 and 2.
     The pair is known by its second diamond's id (same as the old earring pages). */
  function half(x, n) { var o = {}; Object.keys(x || {}).forEach(function (k) { var m = k.match(/^(.*?)([12])$/); if (m && m[2] === String(n)) o[m[1]] = x[k]; }); return o; }
  function normPair(x) {
    var a = normD(half(x, 1)), b = normD(half(x, 2));
    function both(k) { return a[k] === b[k] ? a[k] : [a[k], b[k]].filter(Boolean).join(' / '); }
    return {
      pair: true, type: 'pair', id: b.id, id1: a.id, stones: [a, b], shape: a.shape || b.shape,
      carat: Math.round((a.carat + b.carat) * 100) / 100, color: both('color'), clarity: both('clarity'), cut: both('cut'),
      lab: a.lab || b.lab, cert: [a.cert, b.cert].filter(Boolean).join(' / '), certUrl: a.certUrl,
      img: a.img || b.img, v360: a.v360 || b.v360, meas: a.meas, ratio: a.ratio, seller: a.seller,
      price: a.price + b.price, cost: a.cost + b.cost
    };
  }

  /* our own matched pairs (earrings): two single diamonds from the lab feed, paired by us.
     Rules (a jeweler's stud match): same shape, color, clarity, lab and fluorescence; round also the
     same cut grade; carat within 0.05; round diameter within 0.10 mm, fancy shapes length and width
     each within 0.15 mm and ratio within 0.05. Every diamond is used in one pair only, closest first. */
  var PAIR_CT = 0.05, PAIR_MM_ROUND = 0.10, PAIR_MM_FANCY = 0.15, PAIR_RATIO = 0.05;
  function pmm(d) { return String(d.meas || '').split(/\s*[x×*]\s*/).map(parseFloat).filter(function (n) { return n > 0; }); }
  function fluorKey(f) { f = String(f || '').toLowerCase(); return (!f || f === '-' || /none/.test(f)) ? 'n' : /faint|very slight/.test(f) ? 'f' : /slight|medium/.test(f) ? 'm' : 's'; }
  function pairOf(a, b) {
    if (a.carat > b.carat || (a.carat === b.carat && String(a.id) > String(b.id))) { var t = a; a = b; b = t; }
    function both(k) { return a[k] === b[k] ? a[k] : [a[k], b[k]].filter(Boolean).join(' / '); }
    return {
      pair: true, own: true, type: 'pair', id: 'm' + a.id + '-' + b.id, id1: a.id, stones: [a, b], shape: a.shape || b.shape,
      carat: Math.round((a.carat + b.carat) * 100) / 100, color: both('color'), clarity: both('clarity'), cut: both('cut'),
      lab: a.lab || b.lab, cert: [a.cert, b.cert].filter(Boolean).join(' / '), certUrl: a.certUrl,
      img: a.img || b.img, v360: a.v360 || b.v360, meas: a.meas, ratio: a.ratio, seller: a.seller,
      price: a.price + b.price, cost: a.cost + b.cost
    };
  }
  function pairGap(a, b) { // null when the two do not match, else how far apart they are (smaller is closer)
    var ma = pmm(a), mb = pmm(b); if (ma.length < 2 || mb.length < 2) return null;
    var dc = Math.abs(a.carat - b.carat); if (dc > PAIR_CT + 1e-9) return null;
    var g;
    if (cap(a.shape) === 'Round') {
      g = Math.abs((ma[0] + ma[1]) / 2 - (mb[0] + mb[1]) / 2); if (g > PAIR_MM_ROUND + 1e-9) return null;
    } else {
      var dl = Math.abs(Math.max(ma[0], ma[1]) - Math.max(mb[0], mb[1])), dw = Math.abs(Math.min(ma[0], ma[1]) - Math.min(mb[0], mb[1]));
      if (dl > PAIR_MM_FANCY + 1e-9 || dw > PAIR_MM_FANCY + 1e-9) return null;
      var ra = parseFloat(a.ratio) || Math.max(ma[0], ma[1]) / Math.min(ma[0], ma[1]), rb = parseFloat(b.ratio) || Math.max(mb[0], mb[1]) / Math.min(mb[0], mb[1]);
      if (Math.abs(ra - rb) > PAIR_RATIO + 1e-9) return null;
      g = (dl + dw) / 2;
    }
    return g + dc * 2 + Math.abs(a.price - b.price) / Math.max(a.price, b.price, 1) * 0.05;
  }
  function matchPairs(list, used) {
    used = used || {};
    var groups = {};
    list.forEach(function (d) {
      if (used[d.id] || !(d.carat > 0)) return;
      var k = [cap(d.shape), d.color, d.clarity, d.lab, fluorKey(d.fluor), cap(d.shape) === 'Round' ? d.cut : ''].join('|');
      (groups[k] = groups[k] || []).push(d);
    });
    var edges = [];
    Object.keys(groups).forEach(function (k) {
      var g = groups[k].sort(function (x, y) { return x.carat - y.carat; });
      for (var i = 0; i < g.length; i++) for (var j = i + 1; j < g.length && g[j].carat - g[i].carat <= PAIR_CT + 1e-9; j++) {
        var gap = pairGap(g[i], g[j]); if (gap != null) edges.push([gap, g[i], g[j]]);
      }
    });
    edges.sort(function (x, y) { return x[0] - y[0]; });
    var out = [];
    edges.forEach(function (e) { if (used[e[1].id] || used[e[2].id]) return; used[e[1].id] = used[e[2].id] = 1; out.push(pairOf(e[1], e[2])); });
    return out;
  }
  function sortPairs(list, sort) {
    var k = sort.split('|'), dir = k[1] === 'DESC' ? -1 : 1;
    return list.sort(function (x, y) { return (k[0] === 'size' ? (x.carat - y.carat) || (x.price - y.price) : (x.price - y.price) || (y.carat - x.carat)) * dir; });
  }

  /* ---------- steps bar ---------- */
  var SETTINGS_URL = root.getAttribute('data-settings-url') || '/collections/engagement-ring-settings-shape';
  /* ---------- wishlist (assets/ts-wishlist.js): hearts save recipes, never build products ---------- */
  function wish(el, fn) { if (!el) return; el._tsw = fn; if (window.TSW) window.TSW.paint(); }
  function diamondItem(d) {
    var type = d.pair ? 'pair' : isNat(d) ? 'natural' : 'lab';
    return {
      key: 'g:' + type + ':' + d.id, kind: 'diamond', build: KIND, dtype: type, id: String(d.id), id1: d.id1 ? String(d.id1) : '',
      title: diamondTitle(d), sub: [grades(d), d.lab + (d.cert ? ' ' + d.cert : '')].filter(Boolean).join(' · '),
      image: d.img || shapeIcon(d.shape), price: d.price, url: dUrl(d), builder: BUILDER, settingsUrl: SETTINGS_URL,
      shape: cap(d.shape), carat: d.pair && d.stones ? d.stones[0].carat : d.carat, diamond: d
    };
  }
  // on a setting's own page, step 1 shows the setting being viewed (not an earlier pick) until it is chosen
  var VIEWING = null;
  function step1(s) {
    var v = VIEWING && VIEWING();
    if (v && !(s && s.handle === v.handle)) return { href: location.pathname + location.search, val: v.design + ' · ' + money(v.price), done: false, chg: '' };
    return { href: s ? s.link : SETTINGS_URL, val: s ? s.design + ' · ' + money(s.price) : '', done: !!s, chg: s ? SETTINGS_URL : '' };
  }
  function renderSteps(current) {
    var bar = $('[data-tsb-steps]'); if (!bar) return;
    var s = state.setting, d = state.diamond, one = step1(s);
    if (GEM) {
      var g = state.gem;
      $$('[data-tsb-step]', bar).forEach(function (el) { el.classList.toggle('is-current', +el.dataset.tsbStep === current); });
      var gs = function (n, href, val, done, chg) {
        var el = $('[data-tsb-step="' + n + '"]', bar), main = $('[data-tsb-step-link]', el), c = $('[data-tsb-step-chg]', el);
        main.href = href; if (val) $('[data-tsb-step-val]', el).textContent = val;
        el.classList.toggle('is-done', !!done); if (c) { c.hidden = !chg; if (chg) c.href = chg; }
      };
      gs(1, one.href, one.val, one.done, one.chg);
      gs(2, g ? bUrl({ gem: g.h }) : bUrl({}), g ? g.t + ' · ' + money(g.price) : '', !!g, g ? bUrl({}) : '');
      gs(3, s && g ? bUrl({ step: 'complete' }) : '#', s && g ? money(s.price + g.price) : '', false, '');
      $('[data-tsb-step="3"]', bar).classList.toggle('is-off', !(s && g));
      return;
    }
    $$('[data-tsb-step]', bar).forEach(function (el) { el.classList.toggle('is-current', +el.dataset.tsbStep === current); });
    function step(n) { return $('[data-tsb-step="' + n + '"]', bar); }
    function set(n, href, val, done, chg) {
      var el = step(n), main = $('[data-tsb-step-link]', el), c = $('[data-tsb-step-chg]', el);
      main.href = href; if (val) $('[data-tsb-step-val]', el).textContent = val;
      el.classList.toggle('is-done', !!done);
      if (c) { c.hidden = !chg; if (chg) c.href = chg; }
    }
    // 1: your setting (or the list); "Change" goes back to all settings
    set(1, one.href, one.val, one.done, one.chg);
    // 2: your diamond (or the list); "Change" goes back to all diamonds
    set(2, d ? dUrl(d) : bUrl({ step: 'diamond' }), d ? ct(d.carat) + ' ct ' + cap(d.shape) + ' · ' + money(d.price) : '', !!d, d ? bUrl({ step: 'diamond' }) : '');
    set(3, s && d ? bUrl({ step: 'complete' }) : '#', s && d ? money(s.price + d.price) : '', false, '');
    step(3).classList.toggle('is-off', !(s && d));
  }

  /* ---------- simple gallery (thumbs on desktop, swipe on mobile) ---------- */
  function gallery(wrap, slides) {
    var track = $('[data-tsb-track]', wrap), thumbs = $('[data-tsb-thumbs]', wrap), dots = $('[data-tsb-dots]', wrap);
    if (!slides.length) return;
    track.innerHTML = slides.map(function (s) {
      return '<div class="ts2-slide">' + (s.html || '<img src="' + esc(s.src) + '" alt="' + esc(s.alt || '') + '" width="1000" height="1000"' + (s.lazy ? ' loading="lazy"' : '') + '>') + '</div>';
    }).join('');
    thumbs.innerHTML = slides.map(function (s, i) {
      return '<button type="button" data-i="' + i + '" class="' + (i ? '' : 'is-active') + '" aria-label="View ' + (i + 1) + '">' + (s.thumb ? s.thumb : '<img src="' + esc(s.src) + '" alt="" width="80" height="80" loading="lazy">') + '</button>';
    }).join('');
    dots.innerHTML = slides.length > 1 ? slides.map(function (_, i) { return '<span class="' + (i ? '' : 'is-active') + '"></span>'; }).join('') : '';
    track.scrollLeft = 0;
    function goTo(i) { track.scrollTo({ left: track.clientWidth * i, behavior: 'auto' }); mark(i); }
    function mark(i) {
      $$('button', thumbs).forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
      $$('span', dots).forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
    }
    thumbs.onclick = thumbs.onmouseover = function (e) { var b = e.target.closest('button[data-i]'); if (b) goTo(+b.dataset.i); };
    track.onscroll = function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); };
  }

  /* shared: metal swatches drawn like the regular product pages */
  function paintSwatches(scope) {
    $$('[data-swatch]', scope).forEach(function (sw) {
      var v = sw.dataset.swatch.toLowerCase();
      sw.style.background = /platinum/.test(v) ? 'radial-gradient(circle at 35% 30%,#f7f8fa,#c9ccd3 60%,#9aa0aa)' : /black/.test(v) ? 'radial-gradient(circle at 35% 30%,#6b6b6b,#2b2b2b 60%,#0e0e0e)' :
        /rose/.test(v) ? 'radial-gradient(circle at 35% 30%,#fbe0d3,#e2a98f 60%,#b87a60)' : /yellow/.test(v) ? 'radial-gradient(circle at 35% 30%,#fff1c2,#e3bb5a 60%,#b48a2e)' : 'radial-gradient(circle at 35% 30%,#ffffff,#d6d8de 60%,#aeb2bb)';
      sw.style.color = /black/.test(v) ? '#e8e8e8' : '#4a4a4a';
      var m = v.match(/(\d{1,2})\s*k/);
      sw.textContent = /platinum/.test(v) ? 'PT' : m ? m[1] + 'K' : '';
    });
  }

  /* =========================================================
     STEP 1a: choose a setting (collection grid)
     ========================================================= */
  if (root.getAttribute('data-tsb') === 'settings') {
    (function () { // Natural / Lab grown switch: remembered for the setting page and the diamond step
      var box = $('[data-tsb-sdtypes]', root); if (!box) return;
      function mark() { var t = prefType(); $$('[data-sdtype]', box).forEach(function (b) { var on = b.dataset.sdtype === t; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', String(on)); }); }
      box.addEventListener('click', function (e) { var b = e.target.closest('[data-sdtype]'); if (!b) return; setPrefType(b.dataset.sdtype); mark(); });
      mark();
    })();
    paintSwatches(root);
    var VIEW = root.getAttribute('data-view') || '';
    var L = { shape: EARRING ? '' : 'Round', metal: '', style: '', price: [0, 999999], sort: 'featured', shown: 24 };
    try { var keep = JSON.parse(sessionStorage.getItem(KEY_STATE + '_list') || 'null'); if (keep) { L.shape = (EARRING && keep.shape === '') ? '' : (keep.shape || L.shape); L.metal = keep.metal || ''; L.style = keep.style || ''; } } catch (e) {}
    // SEO collection pages (oval, blackened gold, ...) open on their own shape / metal
    var PS = root.getAttribute('data-preset-shape'), PM = root.getAttribute('data-preset-metal');
    if (PS) { var psb = $$('[data-shape]', root).map(function (b) { return b.dataset.shape; }).filter(function (x) { return x && x.toLowerCase() === PS.toLowerCase(); })[0]; if (psb) L.shape = psb; }
    if (PM) { var pmb = $$('[data-metal]', root).map(function (b) { return b.dataset.metal; }).filter(function (x) { return x && colorWord(x) === colorWord(PM); })[0]; if (pmb) L.metal = pmb; }
    var cards = $$('.tsb-lcard', root), grid = $('[data-tsb-lgrid]', root);
    var MIX = ['18K White Gold', '18K Yellow Gold', '18K Rose Gold'];
    var DOT = { white: '#d6d8de', yellow: '#e3bb5a', rose: '#e2a98f', black: '#2b2b2b', platinum: '#c9ccd3' };
    function dotColor(m) { m = m.toLowerCase(); return /platinum/.test(m) ? DOT.platinum : /black/.test(m) ? DOT.black : /rose/.test(m) ? DOT.rose : /yellow/.test(m) ? DOT.yellow : DOT.white; }
    cards.forEach(function (c, i) {
      c._v = {}; c.getAttribute('data-variants').split('|').forEach(function (x) { var p = x.split(':'); c._v[p[0]] = { id: p[1], price: +p[2] }; });
      var ms = Object.keys(c._v);
      // first look: rings shown in a mix of metals (white, yellow, rose), so the grid shows the range
      var mixWant = ['white', 'yellow', 'rose'][i % 3];
      c._mix = ms.filter(function (m) { return colorWord(m) === mixWant; })[0] || ms[0];
      // metals sit on the style line ("Classic Halo · 5 metals"), no extra row
      var kindEl = $('.tsb-lcard__kind', c);
      if (ms.length > 1) kindEl.innerHTML = '<span class="tsb-lcard__k">' + esc(kindEl.textContent.trim()) + '</span><span class="tsb-lcard__metals">· ' + ms.length + ' metals</span>';
    });
    var CF = 'https://dsv7iunirnrax.cloudfront.net/';
    var TOUCH = window.matchMedia && matchMedia('(hover: none)').matches;
    // hearts on the setting cards save the setting in the metal (and diamond shape) on show
    cards.forEach(function (c) {
      wish($('.tsw-heart', c), function () {
        var v = variantFor(c), m = metalOf(c), a = $('.tsb-lcard__a', c), k = $('.tsb-lcard__k', c) || $('.tsb-lcard__kind', c);
        return {
          key: 's:' + c.dataset.pid, kind: 'setting', build: KIND, pid: String(c.dataset.pid), vid: String(v.id),
          handle: (c.getAttribute('href') || '').split('?')[0].split('/products/')[1] || '', metal: m, shape: L.shape || '',
          title: $('.tsb-lcard__name', c).textContent.trim() + ' ' + W.Setting, sub: [k ? k.textContent.trim() : '', m].filter(Boolean).join(' · '),
          image: a.currentSrc || a.src || a.dataset.fallback || '', price: v.price, make: +c.dataset.make || 0,
          url: c.getAttribute('href'), builder: BUILDER, settingsUrl: location.pathname
        };
      });
    });
    // phones: little dots under the photo follow the swipe (front / side)
    if (TOUCH) grid.addEventListener('scroll', function (e) {
      var ci = e.target; if (!ci.classList || !ci.classList.contains('tsb-lcard__img')) return;
      var on = ci.scrollLeft > ci.clientWidth / 2; ci.parentElement.classList.toggle('is-side', on);
      var c = ci.parentElement; if (c.classList.contains('has-views')) markDot(c, Math.round(ci.scrollLeft / (ci.clientWidth || 1)));
    }, true);
    function photo(c, n, mk) { return CF + c.dataset.pid + '/' + photoPre(c.dataset.sku, L.shape || 'round', '1', mk) + n + '.jpg'; }
    function metalOf(c) {
      if (L.metal) { var w = colorWord(L.metal), k = Object.keys(c._v).filter(function (m) { return colorWord(m) === w; })[0]; if (k) return k; }
      return (c._m && c._v[c._m]) ? c._m : c._mix;
    }
    function variantFor(c) { return c._v[metalOf(c)] || c._v[Object.keys(c._v)[0]]; }
    /* side diamond weight on the card, for the chosen center shape (1 ct center), as on the setting page */
    function sideCt(x) {
      var m = String(x || '').trim().match(/^(\d+)\s+(\d+)\/(\d+)|^(\d+)\/(\d+)|^(\d*\.?\d+)/), n = 0;
      if (m) n = m[1] ? +m[1] + m[2] / m[3] : m[4] ? m[4] / m[5] : parseFloat(m[6]);
      if (!(n > 0)) return ''; var t = n.toFixed(3); return /0$/.test(t) ? n.toFixed(2) : t;
    }
    function paintSide(c) {
      var out = $('[data-side-out]', c); if (!out) return;
      var map = {}; (c.dataset.side || '').split('|').forEach(function (kv) { var p = kv.split(':'); if (p[0] && p[1]) map[p[0].toLowerCase()] = p[1]; });
      var sh = (L.shape || 'round').toLowerCase();
      // a setting not offered in round (no round entry, no single weight) falls back to its first listed shape
      var first = Object.keys(map)[0];
      var w = sideCt(map[sh] || map.round || c.dataset.sideDef || (first ? map[first] : ''));
      out.hidden = !w; out.textContent = w ? 'Side diamonds ' + w + ' ct t.w.' : '';
    }
    function paintCard(c) {
      resetViews(c);
      var m = metalOf(c), a = $('.tsb-lcard__a', c), b = $('.tsb-lcard__b', c), mk = metalKey(m);
      a.onerror = function () {
        if (a.dataset.try === 'wg' || mk === WG) { a.onerror = null; a.src = a.dataset.fallback; return; }
        a.dataset.try = 'wg'; a.src = photo(c, 1, WG);
      };
      a.dataset.try = ''; a.src = photo(c, 1, mk);
      b.onerror = function () { b.removeAttribute('src'); b.hidden = true; };
      b.hidden = false; b.dataset.src = photo(c, 2, mk);
      // phones swipe to the side view: it loads right after the front photo (front photos first); desktop loads it on hover
      if (b.getAttribute('src')) b.src = b.dataset.src;
      else if (TOUCH) { if (a.complete && a.naturalWidth) b.src = b.dataset.src; else a.addEventListener('load', function () { if (!b.getAttribute('src') && b.dataset.src) b.src = b.dataset.src; }, { once: true }); }
      var ci = $('.tsb-lcard__img', c); if (ci.scrollLeft) ci.scrollLeft = 0;
      var v = variantFor(c);
      $('[data-price-out]', c).textContent = money(v.price);
      paintSide(c);
      var base = c.getAttribute('href').split('?')[0];
      var q = new URLSearchParams(); if (VIEW) q.set('view', VIEW); q.set('variant', v.id); if (L.shape) q.set('shape', L.shape);
      var CQ = root.getAttribute('data-card-query');
      c.href = base + '?' + (CQ ? CQ + '&' : '') + q.toString();
      if (viewIO) viewIO.observe(c); else loadViews(c);
    }
    // the second photo loads on first hover only
    grid.addEventListener('mouseover', function (e) { var c = e.target.closest('.tsb-lcard'); if (!c) return; var b = $('.tsb-lcard__b', c); if (!b.getAttribute('src') && b.dataset.src) b.src = b.dataset.src; });
    function apply() {
      try { sessionStorage.setItem(KEY_STATE + '_list', JSON.stringify({ shape: L.shape, metal: L.metal, style: L.style })); } catch (e) {}
      $$('[data-shape]', root).forEach(function (b) { var on = b.dataset.shape === L.shape; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', String(on)); });
      $$('[data-metal]', root).forEach(function (b) { b.classList.toggle('is-selected', L.metal ? (b.dataset.metal && colorWord(b.dataset.metal) === colorWord(L.metal)) : !b.dataset.metal); });
      $$('[data-style]', root).forEach(function (b) { b.classList.toggle('is-selected', b.dataset.style === L.style); });
      var sh = L.shape.toLowerCase() + '|';
      var list = cards.filter(function (c) {
        var v = variantFor(c);
        return (!L.shape || !c.dataset.shapes || c.dataset.shapes.indexOf(sh) > -1) &&
          (!L.style || ('|' + c.dataset.styles + '|').indexOf('|' + L.style + '|') > -1) &&
          v.price >= L.price[0] * 100 && v.price < L.price[1] * 100;
      });
      list.sort(function (a, b) {
        if (L.sort === 'price-asc') return variantFor(a).price - variantFor(b).price;
        if (L.sort === 'price-desc') return variantFor(b).price - variantFor(a).price;
        if (L.sort === 'make-asc') return (+a.dataset.make || 999) - (+b.dataset.make || 999);
        return a.dataset.i - b.dataset.i;
      });
      cards.forEach(function (c) { c.hidden = true; });
      list.forEach(function (c) { grid.appendChild(c); });
      var keep = L.painted || 0;   // keep as many rings showing as before, so the page doesn't jump
      L.list = list; L.painted = 0;
      do { showMore(); } while (L.painted < Math.min(keep, list.length));
      assignVideos();
      $$('[data-tsb-count]', root).forEach(function (el) { el.textContent = list.length + ' ' + W.setting + (list.length === 1 ? '' : 's'); });
      var pt = $('[data-tsb-fpill-text]', root); if (pt) pt.textContent = (L.shape || 'All shapes') + ' · ' + (L.metal ? L.metal.replace(/1[48]K /, '') : 'All metals');
      $('[data-tsb-more]', root).hidden = true;
      $('[data-tsb-empty]', root).hidden = list.length > 0;
    }
    root.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-shape]'))) { L.shape = b.dataset.shape; return apply(); }
      if ((b = e.target.closest('[data-metal]'))) { L.metal = b.dataset.metal; cards.forEach(function (c) { c._m = ''; }); return apply(); }
      if ((b = e.target.closest('[data-style]'))) { L.style = b.dataset.style; return apply(); }

    });
    // endless scroll: the next 24 rings appear before the shopper reaches the end (only those get photos)
    function showMore() {
      var list = L.list || [], end = Math.min(list.length, L.painted + 24);
      for (var i = L.painted; i < end; i++) {
        list[i].hidden = false; paintCard(list[i]);
        if (i < 4) $('.tsb-lcard__a', list[i]).setAttribute('fetchpriority', 'high');
      }
      L.painted = end;
    }
    /* ---- every view of the setting + the video rule of the jewelry collection pages ----
       Each card asks the image list (cached per piece, the same list the setting page uses) for its photos and
       video in the chosen shape + metal, once it is near the screen.
       Phones: swipe through every photo (up to 8), dots follow. Desktop: hover shows the 2nd photo as before;
       arrows step through all of them.
       Videos: none in the first 4 pieces; after that the first piece with a video in each run of 16 plays it
       (muted, only while on screen); hovering shows the front photo. */
    var MAXV = 8;
    var HOVER = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
    var viewIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { viewIO.unobserve(e.target); loadViews(e.target); } });
    }, { rootMargin: '400px 0px' }) : null;
    var vidIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (!v.getAttribute('src')) v.src = v.dataset.src; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else if (v.getAttribute('src')) v.pause();
      });
    }, { rootMargin: '200px 0px' }) : null;
    function setDots(c, n) {
      var sw = $('.tsb-lcard__sw', c); if (!sw) return;
      var h = ''; for (var k = 0; k < n; k++) h += '<i></i>';
      sw.innerHTML = h; markDot(c, 0);
    }
    function markDot(c, i) { $$('.tsb-lcard__sw i', c).forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }
    function resetViews(c) {
      if (viewIO) viewIO.unobserve(c);
      c._views = null; c._vkey = ''; c._vi = 1; c._browse = false;
      var ci = $('.tsb-lcard__img', c);
      $$('.tsb-lcard__x, .tsb-lcard__arw', ci).forEach(function (x) { x.remove(); });
      var v = $('.tsb-lcard__v', ci); if (v) { if (vidIO) vidIO.unobserve(v); v.pause && v.pause(); v.remove(); }
      if (c.classList.contains('has-views')) setDots(c, 2);
      c.classList.remove('has-vid', 'has-views', 'is-browsing');
    }
    function loadViews(c) {
      var key = (L.shape || 'round') + '|' + metalOf(c);
      c._vkey = key;
      imageList(c.dataset.pid).then(function (list) {
        if (c._vkey !== key) return;                         // shape or metal changed meanwhile
        var f = Array.isArray(list) ? settingFiles(list, c.dataset.sku, L.shape || 'round', metalOf(c), '1') : { photos: [], video: '' };
        c._views = { photos: f.photos.slice(0, MAXV), video: f.video || '' };
        buildViews(c);
        assignVideos();
      });
    }
    function buildViews(c) {
      var V = c._views; if (!V || V.photos.length < 2) return;
      var ci = $('.tsb-lcard__img', c), b = $('.tsb-lcard__b', c);
      c.classList.add('has-views');
      if (!b.getAttribute('src') || b.hidden) { b.hidden = false; b.onerror = null; b.dataset.src = V.photos[1]; if (TOUCH) b.src = V.photos[1]; }
      if (TOUCH) {
        var aImg = $('.tsb-lcard__a', c), baseAlt = aImg ? (aImg.getAttribute('alt') || '') : '';
        V.photos.slice(2).forEach(function (u, k) {
          var im = document.createElement('img');
          im.className = 'tsb-lcard__x'; im.alt = baseAlt ? baseAlt + ', view ' + (k + 3) : ''; im.width = 500; im.height = 500; im.loading = 'lazy'; im.decoding = 'async'; im.src = u;
          ci.appendChild(im);
        });
        setDots(c, V.photos.length + (c.classList.contains('has-vid') ? 1 : 0));
      } else if (HOVER) {
        ['prev', 'next'].forEach(function (dir) {
          var bt = document.createElement('span');
          bt.className = 'tsb-lcard__arw tsb-lcard__arw--' + dir; bt.setAttribute('role', 'button');
          bt.setAttribute('aria-label', dir === 'prev' ? 'Previous photo' : 'Next photo');
          bt.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M14.5 6l-6 6 6 6' : 'M9.5 6l6 6-6 6') + '"/></svg>';
          ci.appendChild(bt);
        });
      }
    }
    /* desktop arrows: hovering already shows photo 2, so the first click goes to photo 3; back at photo 2 = normal hover */
    function step(c, d) {
      var V = c._views; if (!V || V.photos.length < 2) return;
      var n = V.photos.length, a = $('.tsb-lcard__a', c);
      if (!c._browse) c._vi = c.classList.contains('has-vid') ? 0 : 1;
      c._vi = (c._vi + d + n) % n;
      if (!c._browse) { c._front = a.getAttribute('src'); }
      c._browse = true; c.classList.add('is-browsing');
      a.style.opacity = '0';
      setTimeout(function () { a.src = V.photos[c._vi]; a.addEventListener('load', function () { a.style.opacity = ''; }, { once: true }); setTimeout(function () { a.style.opacity = ''; }, 500); }, 150);
    }
    grid.addEventListener('click', function (e) {
      var bt = e.target.closest && e.target.closest('.tsb-lcard__arw'); if (!bt) return;
      e.preventDefault(); e.stopPropagation();
      step(bt.closest('.tsb-lcard'), bt.classList.contains('tsb-lcard__arw--prev') ? -1 : 1);
    }, true);
    grid.addEventListener('mouseout', function (e) {
      var c = e.target.closest && e.target.closest('.tsb-lcard'); if (!c || !c._browse) return;
      if (e.relatedTarget && c.contains(e.relatedTarget)) return;
      c._browse = false; c.classList.remove('is-browsing');
      var a = $('.tsb-lcard__a', c); if (c._front) a.src = c._front;
    });
    function addVideo(c) {
      var ci = $('.tsb-lcard__img', c), a = $('.tsb-lcard__a', c);
      var v = document.createElement('video');
      v.className = 'tsb-lcard__v'; v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'none';
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
      v.dataset.src = c._views.video; v.poster = a.currentSrc || a.src || '';
      ci.insertBefore(v, ci.firstChild);
      c.classList.add('has-vid', 'has-views');
      if (TOUCH) setDots(c, Math.max(c._views.photos.length, 1) + 1);
      if (vidIO) vidIO.observe(v); else { v.src = v.dataset.src; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    }
    /* RULE (set by Amit, do not change): no video in the first 4 pieces; after that one video per run of 16 */
    function assignVideos() {
      var list = L.list || [], n = Math.min(L.painted || 0, list.length);
      for (var s0 = 0; s0 < n; s0 += 16) {
        for (var i = Math.max(s0, 4); i < Math.min(s0 + 16, n); i++) {
          var c = list[i];
          if (!c._views) break;                        // wait until this card's list has arrived
          if (c.classList.contains('has-vid')) break;  // this run already has its video
          if (c._views.video) { addVideo(c); break; }
        }
      }
    }
    var sentinel = document.createElement('div'); sentinel.className = 'tsb-sentinel'; grid.after(sentinel);
    function nearEnd() { return L.list && L.painted < L.list.length && sentinel.getBoundingClientRect().top < innerHeight + 900; }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting && nearEnd()) showMore(); }, { rootMargin: '900px 0px' }).observe(sentinel);
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      setTimeout(function () { ticking = false; var n = 0; while (nearEnd() && n++ < 3) showMore(); }, 120);
    }, { passive: true });
    // pinned shape + metal: slim bar on desktop, floating pill + sheet on phones
    var fbar = $('[data-tsb-fbar]', root), fpill = $('[data-tsb-fpill]', root), fsheet = $('[data-tsb-fsheet]', root), lbar = $('[data-tsb-lbar]', root);
    function headerBottom() {
      var h = document.querySelector('sticky-header') || document.querySelector('.shopify-section-header-sticky') || document.querySelector('header');
      var b = h ? h.getBoundingClientRect().bottom : 0; return b > 0 ? b : 0;
    }
    var pinTick = false;
    function pin() {
      pinTick = false;
      var past = lbar.getBoundingClientRect().bottom < headerBottom() + 8;
      var gridEnd = grid.getBoundingClientRect().bottom < innerHeight * 0.6;
      var on = past && !gridEnd;
      fbar.style.top = headerBottom() + 'px';
      fbar.classList.toggle('is-on', on); fbar.setAttribute('aria-hidden', String(!on));
      fpill.hidden = !on || !fsheet.hidden;
    }
    window.addEventListener('scroll', function () { if (!pinTick) { pinTick = true; setTimeout(pin, 60); } }, { passive: true });
    window.addEventListener('resize', pin);
    fpill.addEventListener('click', function () { fsheet.hidden = false; fpill.hidden = true; document.body.style.overflow = 'hidden'; });
    fsheet.addEventListener('click', function (e) {
      if (e.target === fsheet || e.target.closest('[data-tsb-fsheet-close]')) { fsheet.hidden = true; document.body.style.overflow = ''; pin(); }
    });
    $('[data-f="sort"]', root).addEventListener('change', function (e) { L.sort = e.target.value; apply(); });
    $('[data-f="price"]', root).addEventListener('change', function (e) { L.price = e.target.value.split('-').map(Number); apply(); });
    apply();
    renderSteps(1);
    return;
  }

  /* =========================================================
     STEP 1: setting page
     ========================================================= */
  if (root.getAttribute('data-tsb') === 'setting') {
    var S = JSON.parse($('[data-tsb-setting]').textContent);
    if (KIND === 'ring' && !GEM) S.maxCt = Math.max(parseFloat(S.maxCt) || 4, RING_MAX_CT);   // every ring setting can be made with a larger center
    VIEWING = function () { return { handle: S.handle, design: S.design, price: cur.v.price }; };
    var ACC = []; try { ACC = JSON.parse($('[data-tsb-accents]').textContent); } catch (e) {}
    var params = new URLSearchParams(location.search);
    var shapes = $$('[data-shape]', root).map(function (b) { return b.dataset.shape; });
    function findShape(x) { x = String(x || '').toLowerCase(); return shapes.filter(function (s) { return s.toLowerCase() === x; })[0]; }
    var saved = state.setting && state.setting.handle === S.handle ? state.setting : null;
    var vById = {}; S.variants.forEach(function (v) { vById[v.id] = v; });
    var cur = {
      shape: findShape(params.get('shape')) || (GEM && state.gem && findShape(state.gem.shape)) || (state.diamond && findShape(state.diamond.shape)) || (saved && findShape(saved.shape)) || findShape(S.defaultShape) || shapes[0],
      carat: (saved && saved.carat) || '1',
      v: vById[S.selectedVariant] || (saved && vById[saved.vid]) ||
        S.variants.filter(function (v) { return S.defaultMetal && v.title.toLowerCase().indexOf(S.defaultMetal.toLowerCase()) > -1; })[0] || S.variants[0]
    };
    if (!$('[data-carat="' + cur.carat + '"]', root)) cur.carat = ($('[data-carat="1"]', root) ? '1' : (($('[data-carat]', root) || {}).dataset || {}).carat);
    var list = [];
    var MM = { round: [6.5], oval: [7.7, 5.7], cushion: [6.0, 5.6], pear: [8.5, 5.5], princess: [5.5], emerald: [7.0, 5.0], marquise: [10.0, 5.0], asscher: [5.5], heart: [6.5, 6.8], radiant: [6.5, 5.2] };

    function ctVal(key) { var b = $('[data-carat="' + key + '"]', root); return b ? parseFloat(b.dataset.ct) : 1; }
    function token(key) { return String(key).replace(/\s+/g, '').replace('/', '-'); }
    function mm(shape, ct) {
      var b = MM[String(shape).toLowerCase()] || [6.5], f = Math.cbrt(ct);
      return b.length > 1 ? (b[0] * f).toFixed(1) + ' × ' + (b[1] * f).toFixed(1) + ' mm' : (b[0] * f).toFixed(1) + ' mm';
    }
    function files(sku, shape, key, metal) {
      // photos (+ optional video) for this look; falls back to the 1 ct render, then white gold for platinum
      function pick(tk, mk) {
        var pre = photoPre(sku, shape, tk, mk);
        return list.filter(function (u) { return u.split('/').pop().toLowerCase().indexOf(pre) === 0; })
          .sort(function (a, b) { return (parseInt(a.split('-').pop(), 10) || 0) - (parseInt(b.split('-').pop(), 10) || 0); });
      }
      var mk = metalKey(metal), tk = token(key), exact = true;
      var got = pick(tk, mk);
      if (!got.length && /platinum/i.test(metal)) { mk = WG; got = pick(tk, mk); }
      if (!got.length) { exact = false; tk = '1'; got = pick(tk, metalKey(metal)); if (!got.length) { mk = WG; got = pick(tk, mk); } }
      return {
        photos: got.filter(function (u) { return /\.(jpe?g|png|webp)$/i.test(u); }),
        video: got.filter(function (u) { return /\.mp4$/i.test(u); })[0] || '',
        exact: exact, tk: tk, mk: mk
      };
    }

    /* ---- 360° spin, drawn inside the big image ---- */
    var spin = { key: '', frames: [], n: 0, i: 0, timer: null, ready: false };
    var spinEl = $('[data-tsb-spin]', root), spinImg = $('[data-tsb-spin-img]', root);
    function probe(u) { return new Promise(function (res) { var im = new Image(); im.onload = function () { res(true); }; im.onerror = function () { res(false); }; im.src = u; }); }
    function spinBase(f) { return 'https://dsv7iunirnrax.cloudfront.net/360/' + S.pid + '/' + String(cur.v.sku).toLowerCase() + '_' + cur.shape.toLowerCase() + '_' + f.tk + '_' + f.mk + '-4/frame'; }
    function frameUrl(base, i) { return base + (i < 10 ? '0' + i : i) + '.png'; }
    var spinCheck = {};
    function check360(f) {
      var base = spinBase(f);
      if (!spinCheck[base]) spinCheck[base] = probe(frameUrl(base, 1)).then(function (ok) {
        if (!ok) return 0;
        var lo = 1, hi = 181;  // count the frames (binary search; usually 72-75)
        function step() {
          if (hi - lo <= 1) return Promise.resolve(lo);
          var m = (lo + hi) >> 1;
          return probe(frameUrl(base, m)).then(function (y) { if (y) lo = m; else hi = m; return step(); });
        }
        return step();
      });
      return spinCheck[base].then(function (n) { return { base: base, n: n }; });
    }
    function openSpin() {
      var f = files(cur.v.sku, cur.shape, cur.carat, cur.v.title);
      check360(f).then(function (r) {
        if (!r.n) return;
        mode('spin');
        if (spin.key === r.base && spin.ready) return autoSpin();
        stopSpin(); spin.key = r.base; spin.n = r.n; spin.frames = []; spin.ready = false; spin.i = 0;
        var loaded = 0, load = $('[data-tsb-spin-load]', root);
        load.textContent = 'Loading 360° 0%'; load.hidden = false;
        spinImg.src = frameUrl(r.base, 1);
        for (var i = 1; i <= r.n; i++) (function (i) {
          var im = new Image();
          im.onload = im.onerror = function () {
            loaded++; load.textContent = 'Loading 360° ' + Math.round(loaded * 100 / r.n) + '%';
            if (loaded === r.n && spin.key === r.base) { spin.ready = true; load.hidden = true; autoSpin(); }
          };
          im.src = frameUrl(r.base, i); spin.frames[i - 1] = im.src;
        })(i);
      });
    }
    function showFrame(i) { spin.i = (i % spin.n + spin.n) % spin.n; spinImg.src = spin.frames[spin.i]; }
    function autoSpin() { stopSpin(); spin.timer = setInterval(function () { showFrame(spin.i + 1); }, 70); }
    function stopSpin() { if (spin.timer) clearInterval(spin.timer); spin.timer = null; }
    (function drag() {
      var x0 = null, i0 = 0;
      spinEl.addEventListener('pointerdown', function (e) { if (!spin.ready) return; stopSpin(); x0 = e.clientX; i0 = spin.i; spinEl.setPointerCapture(e.pointerId); $('[data-tsb-spin-hint]', root).hidden = true; });
      spinEl.addEventListener('pointermove', function (e) { if (x0 == null) return; showFrame(i0 - Math.round((e.clientX - x0) / (spinEl.clientWidth / spin.n * 1.4))); });
      spinEl.addEventListener('pointerup', function () { x0 = null; });
      spinEl.addEventListener('pointercancel', function () { x0 = null; });
    })();

    /* ---- big image modes: photos | spin | video ---- */
    var vidEl = $('[data-tsb-video]', root);
    function mode(m) {
      $('[data-tsb-track]', root).style.visibility = m === 'photos' ? '' : 'hidden';
      spinEl.hidden = m !== 'spin';
      $('[data-tsb-vid]', root).hidden = m !== 'video';
      if (m !== 'spin') stopSpin();
      if (m === 'video') { vidEl.play().catch(function () {}); } else { vidEl.pause(); }
      $('[data-tsb-photos]', root).hidden = m === 'photos';
      $$('[data-tsb-thumbs] button', root).forEach(function (b) { b.classList.toggle('is-active', m === 'photos' ? b.dataset.i === '0' && !b.dataset.mode : b.dataset.mode === m); });
    }

    var lastLook = '';
    function drawGallery(f) {
      var look = f.photos.join('|') + f.video;
      if (look === lastLook) return; lastLook = look;
      var alt = 'The ' + S.design + ', ' + cur.shape + ', ' + cur.v.title;
      var slides = f.photos.map(function (u, i) { return { src: u, alt: alt, lazy: i > 0 }; });
      // the ring box is always the last photo, on every setting
      var boxImg = root.getAttribute('data-ringbox');
      if (slides.length && boxImg) slides.push({ src: boxImg, alt: 'True Sanity ' + (PENDANT || EARRING ? 'jewelry' : 'ring') + ' box', lazy: true });
      if (slides.length) gallery($('[data-tsb-gallery]', root), slides);
      var thumbs = $('[data-tsb-thumbs]', root);
      if (f.video) {
        vidEl.src = f.video;
        thumbs.insertAdjacentHTML('beforeend', '<button type="button" data-mode="video" class="tsb-thumbtool" aria-label="Play video"><svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5v14l12-7z" fill="currentColor"/></svg><span>Video</span></button>');
      } else vidEl.removeAttribute('src');
      $('[data-tsb-play]', root).hidden = !f.video;
      $('[data-tsb-360]', root).hidden = true;
      check360(f).then(function (r) {
        if (!r.n || lastLook !== look) return;
        $('[data-tsb-360]', root).hidden = false;
        thumbs.insertAdjacentHTML('beforeend', '<button type="button" data-mode="spin" class="tsb-thumbtool" aria-label="360° view"><span class="tsb-360">360°</span></button>');
      });
      mode('photos');
    }

    function costLines(v) {
      var c = v.cost;
      return [
        { label: 'Material', cents: c.components, sub: S.isSet ? v.title + ' engagement ring and matching band, with their side diamonds' : v.title + ' and the side diamonds' },
        { label: 'Labor', cents: c.crafting + c.design, sub: 'Design, casting, setting and polishing' },
        { label: 'Logistics', cents: c.packaging + c.duties, sub: 'Packaging, duties and shipping' }
      ].filter(function (l) { return l.cents > 0; });
    }
    function sideFor(shape, key) {
      var sh = String(shape).toLowerCase();
      var hits = ACC.filter(function (a) { return String(a.shape).toLowerCase() === sh; });
      var st = (hits.filter(function (a) { return a.carat === key; })[0] || hits.filter(function (a) { return a.carat === '1'; })[0] || hits[0] || {}).stones || [];
      return st.filter(function (x) { return parseFloat(x.number) > 0 || parseFloat(x.carat) > 0; });
    }
    function drawSide() {
      var st = sideFor(cur.shape, cur.carat);
      var glance = $('[data-tsb-side]', root), spec = $('[data-tsb-side-spec]', root);
      var none = !st.length && !(parseFloat(S.sideCt) > 0);
      $('[data-tsb-side-row]', root).hidden = none; $('[data-tsb-side-block]', root).hidden = none;
      if (none) return;
      if (!st.length) { glance.textContent = 'Approx. ' + ct(S.sideCt) + ' ct t.w.'; spec.innerHTML = '<div><span>Total weight</span><span>Approx. ' + esc(ct(S.sideCt)) + ' ct</span></div>'; return; }
      glance.textContent = st.map(function (s) { return [s.number, s.shape ? s.shape.toLowerCase() : '', '·', [s.color, s.clarity].filter(Boolean).join(' '), s.carat ? '· approx. ' + s.carat.replace(/t\.?w\.?/i, 'ct t.w.') : ''].filter(Boolean).join(' '); }).join(' + ');
      $('[data-tsb-side-shape]', root).textContent = '(with ' + (/^[aeiou]/i.test(cur.shape) ? 'an ' : 'a ') + cur.shape.toLowerCase() + ' center)';
      spec.innerHTML = st.map(function (s) {
        return [['Stones', [s.number, s.shape, s.type].filter(Boolean).join(' ')], ['Color', s.color], ['Clarity', s.clarity], ['Total weight', s.carat ? 'Approx. ' + s.carat.replace(/t\.?w\.?/i, 'ct') : ''], ['Treatment', s.treatment]]
          .filter(function (r) { return r[1]; }).map(function (r) { return '<div><span>' + esc(r[0]) + '</span><span>' + esc(r[1]) + '</span></div>'; }).join('');
      }).join('');
    }
    function drawManifest(v) {
      var lines = costLines(v), total = lines.reduce(function (a, l) { return a + l.cents; }, 0);
      var fee = v.price - total, pct = Math.round(fee * 100 / v.price);
      $('[data-tsb-wemake]', root).textContent = 'What we make: ' + money(fee) + ' (' + pct + '%)';
      $('[data-tsb-msku]', root).textContent = String(v.sku).toUpperCase();
      $('[data-tsb-mlines]', root).innerHTML =
        '<div class="ts2-mcard__rows">' + lines.map(function (l) {
          return '<details class="ts2-mcard__item"><summary class="ts2-mcard__row"><b>' + l.label + '</b><span>' + money2(l.cents) + '</span></summary><div class="ts2-mcard__body"><div class="ts2-mcard__subrow"><span>' + esc(l.sub) + '</span><span></span></div></div></details>';
        }).join('') + '</div>' +
        '<div class="ts2-mcard__rows ts2-mcard__rows--sum">' +
          '<div class="ts2-mcard__row"><b>Total Cost</b><span>' + money2(total) + '</span></div>' +
          '<div class="ts2-mcard__row"><b>Protocol Fee <small>(what we make, ' + pct + '%)</small></b><span>' + money2(fee) + '</span></div>' +
        '</div>' +
        '<div class="ts2-mcard__price"><span>' + (S.isSet ? 'Set Price' : 'Setting Price') + '</span><span>' + money2(v.price) + '</span></div>';
    }
    /* bridal set: what the ring and band cost bought separately; plain ring: offer its bridal set */
    function bandsPrice(b, metal) {
      var t = 0, ok = b && b.bands && b.bands.length;
      (b && b.bands || []).forEach(function (x) { var p = x.prices[metal]; if (p == null) ok = false; else t += p; });
      return ok ? t : null;
    }
    function drawBridal(v) {
      var el = $('[data-tsb-save]', root);
      if (el && S.bridal) {
        var rp = S.bridal.ring && S.bridal.ring.prices[v.title], bp = bandsPrice(S.bridal, v.title);
        var sep = rp != null && bp != null ? rp + bp : 0;
        if (sep > v.price) { el.innerHTML = 'Ring + band bought separately <s>' + money(sep) + '</s> · <b>You save ' + money(sep - v.price) + '</b>'; el.hidden = false; }
        else el.hidden = true;
      }
      var up = $('[data-tsb-upsell]', root), U = S.upsell;
      if (up && U) {
        var sv = U.variants[v.title], bp2 = bandsPrice(U, v.title), band = U.bands[0];
        if (!sv) { up.hidden = true; return; }
        up.hidden = false;
        up.href = U.url + '?variant=' + sv.id + '&shape=' + encodeURIComponent(cur.shape);
        var save = bp2 != null ? v.price + bp2 - sv.price : 0;
        $('[data-tsb-upsell-line]', up).innerHTML = 'Add the matching ' + (band ? esc(band.design) + ' band' : 'band') + ': set price ' + money(sv.price) +
          (save > 0 ? ' · <b>save ' + money(save) + '</b>' : '');
      }
    }
    // "complete ring from": the lowest-priced lab diamond of this shape and carat (G+ / VS2+)
    var fromTimer = null, fromSeq = 0;
    function drawFrom() {
      clearTimeout(fromTimer);
      if (GEM) { var fe = $('[data-tsb-from]', root); if (fe) fe.hidden = true; return; }
      fromTimer = setTimeout(function () {
        var seq = ++fromSeq, c = ctVal(cur.carat), el = $('[data-tsb-from]', root);
        var fromType = NAT_RING && !EARRING ? prefType() : 'lab';
        api('?page=1&limit=' + (EARRING ? 400 : 1) + '&sort_by=total_sales_price&direction=ASC', { method: 'POST', body: {
          color_from: 'D', color_to: 'G', clarity_from: 'VS2', clarity_to: 'IF', cut_from: cur.shape === 'Round' ? 'Excellent' : 'Fair', cut_to: 'Ideal',
          size_from: String(c), size_to: String(Math.round(c * 115) / 100), price_total_from: '0', price_total_to: '1000000',
          labs: fromType === 'natural' ? ['GIA', 'IGI'] : ['IGI'], Shapes: [cur.shape], fluorescence_intensities: ['Very Slight', 'Slight', 'None'],
          polish_from: 'Good', polish_to: 'Excellent', symmetry_from: 'Good', symmetry_to: 'Excellent'
        } }, fromType).then(function (r) {
          if (seq !== fromSeq) return;
          var d = r && r.diamonds && r.diamonds[0], p;
          if (EARRING) { var ps = sortPairs(matchPairs((r.diamonds || []).map(normD)), 'total_sales_price|ASC'); d = ps[0]; p = d && d.price; }
          else if (d) p = Math.round(parseFloat(d.total_sales_price) * 100);
          if (!d) { el.hidden = true; return; }
          el.innerHTML = EARRING
            ? 'Complete earrings with a pair of ' + esc(cur.carat) + ' ct ' + esc(cur.shape.toLowerCase()) + ' lab diamonds: <b>from ' + money(cur.v.price + p) + '</b>'
            : (S.isSet ? 'Complete set with a ' : 'Complete ' + W.piece + ' with a ') + esc(cur.carat) + ' ct ' + esc(cur.shape.toLowerCase()) + (fromType === 'natural' ? ' natural' : ' lab') + ' diamond: <b>from ' + money(cur.v.price + p) + '</b>';
          el.hidden = false;
        }).catch(function () { el.hidden = true; });
      }, 300);
    }
    function addBizDays(n) {
      var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    }

    function draw(prev) {
      var p = prev || {}, shape = p.shape || cur.shape, key = p.carat || cur.carat, v = p.v || cur.v;
      $$('[data-shape]', root).forEach(function (b) { var on = b.dataset.shape === cur.shape; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', String(on)); });
      $$('[data-carat]', root).forEach(function (b) { var on = b.dataset.carat === cur.carat; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', String(on)); });
      $$('[data-vid]', root).forEach(function (b) { var on = +b.dataset.vid === cur.v.id; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', String(on)); });
      $('[data-tsb-cur="shape"]', root).textContent = shape;
      $('[data-tsb-cur="carat"]', root).textContent = key + ' ct';
      $('[data-tsb-mm]', root).textContent = '(approx. ' + mm(shape, ctVal(key)) + ')';
      $('[data-tsb-cur="metal"]', root).textContent = v.title;
      $('[data-tsb-price]', root).textContent = money(v.price);
      $('[data-tsb-sticky-price]', root).textContent = money(v.price);
      $('[data-tsb-spec-metal]', root).textContent = v.title;
      drawBridal(v);
      var f = files(v.sku, shape, key, v.title);
      $('[data-tsb-shown]', root).hidden = !list.length;
      $('[data-tsb-shown]', root).textContent = f.exact ? (EARRING ? 'Shown with ' + key + ' ct ' + shape.toLowerCase() + ' diamonds (each)' : 'Shown with a ' + key + ' ct ' + shape.toLowerCase() + ' diamond')
        : 'Shown with 1 ct. A ' + key + ' ct ' + shape.toLowerCase() + ' is approx. ' + mm(shape, ctVal(key)) + '.';
      if (list.length) drawGallery(f);
      if (!prev) { drawManifest(cur.v); drawSide(); drawFrom(); renderSteps(1); }
    }
    root.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-shape]'))) { cur.shape = b.dataset.shape; return draw(); }
      if ((b = e.target.closest('[data-carat]'))) { cur.carat = b.dataset.carat; return draw(); }
      if ((b = e.target.closest('[data-vid]'))) {
        cur.v = vById[b.dataset.vid]; draw();
        var u = new URL(location.href); u.searchParams.set('variant', cur.v.id); history.replaceState(null, '', u);
        return;
      }
      if (e.target.closest('[data-tsb-360]') || e.target.closest('[data-mode="spin"]')) return openSpin();
      if (e.target.closest('[data-tsb-play]') || e.target.closest('[data-mode="video"]')) return mode('video');
      if (e.target.closest('[data-tsb-photos]')) return mode('photos');
      if ((b = e.target.closest('[data-tsb-thumbs] button[data-i]'))) return mode('photos');
      if ((b = e.target.closest('[data-tsb-wemake-btn]'))) {
        var box = $('[data-tsb-sman]', root), open = box.hidden;
        box.hidden = !open; b.setAttribute('aria-expanded', String(open));
        return;
      }
      if (e.target.closest('[data-tsb-choose]')) choose();
    });
    // hover previews the photos and price (desktop); leaving the row goes back
    root.addEventListener('mouseover', function (e) {
      var b = e.target.closest('[data-shape]'); if (b) return draw({ shape: b.dataset.shape });
      b = e.target.closest('[data-carat]'); if (b) return draw({ carat: b.dataset.carat });
      b = e.target.closest('[data-vid]'); if (b) draw({ v: vById[b.dataset.vid] });
    });
    $$('[data-tsb-shapes], [data-tsb-carats], [data-tsb-metals]', root).forEach(function (row) { row.addEventListener('mouseleave', function () { draw({}); }); });
    // metal swatches: same look as the regular product pages
    $$('[data-swatch]', root).forEach(function (s) {
      var v = s.dataset.swatch.toLowerCase();
      s.style.background = /platinum/.test(v) ? 'radial-gradient(circle at 35% 30%,#f7f8fa,#c9ccd3 60%,#9aa0aa)' : /black/.test(v) ? 'radial-gradient(circle at 35% 30%,#6b6b6b,#2b2b2b 60%,#0e0e0e)' :
        /rose/.test(v) ? 'radial-gradient(circle at 35% 30%,#fbe0d3,#e2a98f 60%,#b87a60)' : /yellow/.test(v) ? 'radial-gradient(circle at 35% 30%,#fff1c2,#e3bb5a 60%,#b48a2e)' : 'radial-gradient(circle at 35% 30%,#ffffff,#d6d8de 60%,#aeb2bb)';
      s.style.color = /black/.test(v) ? '#e8e8e8' : '#4a4a4a';
      s.textContent = /platinum/.test(v) ? 'PT' : ((v.match(/(\d{1,2})\s*k/) || [])[1] ? v.match(/(\d{1,2})\s*k/)[1] + 'K' : '');
    });

    function choose() {
      var link = location.pathname + (params.get('view') ? '?view=' + params.get('view') + '&variant=' + cur.v.id : '?variant=' + cur.v.id);
      var f = files(cur.v.sku, cur.shape, cur.carat, cur.v.title);
      state.setting = {
        handle: S.handle, pid: S.pid, vid: cur.v.id, sku: cur.v.sku, metal: cur.v.title, price: cur.v.price, cost: cur.v.cost,
        name: S.name, design: S.design, title: S.title, shape: cur.shape, carat: cur.carat, shapes: shapes, minCt: S.minCt, maxCt: S.maxCt,
        image: f.photos[0] || '', link: link, isSet: !!S.isSet
      };
      if (GEM) {
        // a gemstone already picked stays only if this setting takes its shape
        if (state.gem && shapes.map(function (x) { return x.toLowerCase(); }).indexOf(String(state.gem.shape).toLowerCase()) < 0) delete state.gem;
        save(state);
        location.href = state.gem ? bUrl({ step: 'complete' }) : bUrl({ shape: cur.shape });
        return;
      }
      if (state.diamond && (shapes.map(function (s) { return s.toLowerCase(); }).indexOf(String(state.diamond.shape).toLowerCase()) < 0 || state.diamond.carat < S.minCt || state.diamond.carat > S.maxCt + 0.1)) delete state.diamond;
      save(state);
      var c = ctVal(cur.carat);
      location.href = state.diamond ? bUrl({ step: 'complete' }) : bUrl({ step: 'diamond', shape: cur.shape, ct: c });
    }

    // hearts next to "Choose this setting"
    $$('[data-tsw-setting]', root).forEach(function (h) {
      wish(h, function () {
        var f = files(cur.v.sku, cur.shape, cur.carat, cur.v.title);
        return {
          key: 's:' + S.pid, kind: 'setting', build: KIND, pid: String(S.pid), vid: String(cur.v.id), handle: S.handle, metal: cur.v.title, shape: cur.shape,
          title: 'The ' + S.design + ' ' + (S.isSet ? 'Bridal Set' : W.Setting), sub: cur.v.title + (EARRING ? '' : ' · for a ' + cur.shape + (GEM ? ' gemstone' : ' diamond')),
          image: f.photos[0] || '', price: cur.v.price,
          url: location.pathname + '?' + (params.get('view') ? 'view=' + params.get('view') + '&' : '') + 'variant=' + cur.v.id + '&shape=' + cur.shape,
          builder: BUILDER, settingsUrl: SETTINGS_URL
        };
      });
    });
    // delivery line
    $('[data-tsb-ship]', root).textContent = 'Order now for delivery by ' + addBizDays((parseInt(cur.v.shipDays, 10) || 10) + 7) + ', depending on your ' + (GEM ? 'gemstone' : 'diamond') + '.';
    // mobile sticky bar once the main button scrolls away
    var sticky = $('[data-tsb-sticky]', root), mainBtn = $('.tsb-sbuy [data-tsb-choose]', root);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) {
      sticky.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0;
    }).observe(mainBtn);
    // review stars: drawn by the theme from the product's review metafields (snippets/ts-review-chip)

    imageList(S.pid).then(function (l) { list = l; draw({}); });
    draw();
    renderSteps(1);
    return;
  }

  /* =========================================================
     STEPS 2-3: builder page
     ========================================================= */
  var views = {}; $$('[data-tsb-view]', root).forEach(function (v) { views[v.getAttribute('data-tsb-view')] = v; });
  function show(name) { Object.keys(views).forEach(function (k) { views[k].hidden = k !== name; }); window.scrollTo(0, 0); }
  var cache = {};

  /* ---------- filters ---------- */
  var ALL_SHAPES = ['Round', 'Oval', 'Cushion', 'Pear', 'Princess', 'Emerald', 'Marquise', 'Asscher', 'Radiant', 'Heart'];
  var COLORS = ['D', 'E', 'F', 'G', 'H', 'I', 'J'];
  var CLARITY = ['SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF'];
  var CUTS = ['Good', 'Very Good', 'Excellent', 'Ideal'];
  var FINISH = ['Good', 'Very Good', 'Excellent'];
  var FLUOR = { 'None': ['None'], 'Faint': ['Faint', 'Very Slight'], 'Medium': ['Slight', 'Medium'], 'Strong': ['Strong', 'Very Strong'] };
  var RATIOS = { oval: [[1.3, 1.4], [1.4, 1.5], [1.5, 1.65]], pear: [[1.45, 1.6], [1.6, 1.75], [1.75, 2]], marquise: [[1.75, 2], [2, 2.2]], emerald: [[1.3, 1.45], [1.45, 1.6]], cushion: [[1, 1.1], [1.1, 1.3]], radiant: [[1, 1.1], [1.2, 1.4]] };
  var F = null;
  function defaults() {
    var s = state.setting;
    if (s && KIND === 'ring' && !GEM) s.maxCt = Math.max(parseFloat(s.maxCt) || 4, RING_MAX_CT);
    var lo = s ? Math.max(s.minCt || 0.2, 0.9) : 0.9, hi = s ? Math.min(s.maxCt || 10, 1.5) : 1.5;
    if (hi < lo) { lo = s.minCt; hi = s.maxCt; }
    var p = new URLSearchParams(location.search);
    var sh = p.get('shape') || (s && s.shape) || 'Round';
    var want = parseFloat(p.get('ct'));
    if (want) { lo = want; hi = Math.round(want * 125) / 100; if (s) { lo = Math.max(lo, s.minCt || 0.2); hi = Math.min(hi, (s.maxCt || 10) + 0.1); } }
    return { shape: [cap(sh)], ctMin: lo, ctMax: hi, color: [0, 4], clarity: [2, 6], cut: [2, 3], pMin: '', pMax: '', sort: 'total_sales_price|ASC',
      fluor: ['None', 'Faint', 'Medium', 'Strong'], polish: [0, 2], symmetry: [0, 2], ratio: null,
      type: EARRING ? 'pair' : !NATURAL ? 'lab' : (function () { var q = new URLSearchParams(location.search).get('dt'); return q === 'lab' || q === 'natural' ? q : prefType(); })() };
  }
  function fixF() { // older saved filters
    var d = defaults();
    ['fluor', 'polish', 'symmetry', 'type'].forEach(function (k) { if (!F[k]) F[k] = d[k]; });
    if (EARRING) F.type = 'pair'; else if (!NATURAL) F.type = 'lab';
    if (F.ratio === undefined) F.ratio = null;
  }
  function allowedShapes() {
    var s = state.setting;
    if (!s || !s.shapes || !s.shapes.length) return ALL_SHAPES;
    return s.shapes.map(cap);
  }
  function scaleHTML(list, range) {
    return list.map(function (g, i) { return '<button type="button" data-g="' + i + '" class="' + (i >= range[0] && i <= range[1] ? 'is-on' : '') + '">' + g + '</button>'; }).join('');
  }
  function rangeText(list, r) { return r[0] === r[1] ? list[r[0]] : list[r[0]] + ' to ' + list[r[1]]; }
  function oneShape() { return F.shape.length === 1 ? F.shape[0].toLowerCase() : ''; }
  function activeCount() {
    var d = defaults(), n = 0;
    if (F.color.join() !== d.color.join()) n++;
    if (F.clarity.join() !== d.clarity.join()) n++;
    if (oneShape() === 'round' && F.cut.join() !== d.cut.join()) n++;
    if (F.pMin !== '' || F.pMax !== '') n++;
    if (F.fluor.length !== 4) n++;
    if (F.polish.join() !== '0,2') n++;
    if (F.symmetry.join() !== '0,2') n++;
    if (F.ratio) n++;
    return n;
  }
  function drawFilters() {
    var box = $('[data-tsb-filters]', root);
    var sh = allowedShapes();
    $('[data-f="shape"]', box).innerHTML = sh.map(function (s) {
      var on = F.shape.indexOf(s) > -1;
      return '<button type="button" class="tsb-lshape' + (on ? ' is-selected' : '') + '" data-s="' + s + '" aria-pressed="' + on + '"><span class="tsb-lshape__i"><img src="' + shapeIcon(s) + '" alt="" width="34" height="34" loading="lazy"></span><span>' + s + '</span></button>';
    }).join('');
    $$('[data-f="shape-mini"]', box).forEach(function (el) {
      el.innerHTML = sh.map(function (s) { var on = F.shape.indexOf(s) > -1; return '<button type="button" class="tsb-fshape' + (on ? ' is-selected' : '') + '" data-s="' + s + '" title="' + s + '"><img src="' + shapeIcon(s) + '" alt="" width="22" height="22" loading="lazy"><span>' + s + '</span></button>'; }).join('');
    });
    var pt = $('[data-tsb-dpill-text]', box); if (pt) pt.textContent = F.shape.join(', ') + ' · ' + ct(F.ctMin) + '–' + ct(F.ctMax) + ' ct';
    $('[data-f="ctMin"]', box).value = F.ctMin; $('[data-f="ctMax"]', box).value = F.ctMax;
    var presets = [[0.5, 0.74], [0.75, 0.99], [1, 1.24], [1.25, 1.49], [1.5, 1.99], [2, 2.49], [2.5, 2.99], [3, 3.99], [4, 4.99], [5, 5.99], [6, 50]].filter(function (p) {
      var s = state.setting; return !s || (p[1] >= (s.minCt || 0) && p[0] <= (s.maxCt || 99));
    });
    var ctHtml = presets.map(function (p) {
      var on = Math.abs(F.ctMin - p[0]) < 0.001 && Math.abs(F.ctMax - p[1]) < 0.001;
      return '<button type="button" class="tsb-chip' + (on ? ' is-selected' : '') + '" data-ct="' + p[0] + ',' + p[1] + '">' + (p[0] === 6 ? '6 ct +' : p[0] + ' ct') + '</button>';
    }).join('');
    $$('[data-f="ctPreset"]', box).forEach(function (el) { el.innerHTML = ctHtml; });
    $('[data-f="color"]', box).innerHTML = scaleHTML(COLORS, F.color);
    $('[data-f="clarity"]', box).innerHTML = scaleHTML(CLARITY, F.clarity);
    $('[data-f="cut"]', box).innerHTML = scaleHTML(CUTS, F.cut);
    $('[data-f="polish"]', box).innerHTML = scaleHTML(FINISH, F.polish);
    $('[data-f="symmetry"]', box).innerHTML = scaleHTML(FINISH, F.symmetry);
    $('[data-f="fluor"]', box).innerHTML = Object.keys(FLUOR).map(function (k) { var on = F.fluor.indexOf(k) > -1; return '<button type="button" class="tsb-chip' + (on ? ' is-selected' : '') + '" data-fl="' + k + '" aria-pressed="' + on + '">' + k + '</button>'; }).join('');
    var rs = RATIOS[oneShape()];
    $('[data-ratiorow]', box).hidden = !rs;
    if (rs) $('[data-f="ratio"]', box).innerHTML = '<button type="button" class="tsb-chip' + (!F.ratio ? ' is-selected' : '') + '" data-ra="">Any</button>' +
      rs.map(function (r) { var on = F.ratio && F.ratio[0] === r[0] && F.ratio[1] === r[1]; return '<button type="button" class="tsb-chip' + (on ? ' is-selected' : '') + '" data-ra="' + r.join(',') + '">' + r[0].toFixed(2) + '–' + r[1].toFixed(2) + '</button>'; }).join('');
    $('[data-cutrow]', box).hidden = oneShape() !== 'round';
    $('[data-f="pMin"]', box).value = F.pMin; $('[data-f="pMax"]', box).value = F.pMax;
    $('[data-f="sort"]', box).value = F.sort;
    $('[data-tsb-v="ct"]', box).textContent = ct(F.ctMin) + ' to ' + ct(F.ctMax) + ' ct';
    $('[data-tsb-v="price"]', box).textContent = F.pMin === '' && F.pMax === '' ? 'Any' : (F.pMin === '' ? 'up to $' + F.pMax : '$' + F.pMin + (F.pMax === '' ? '+' : ' to $' + F.pMax));
    $('[data-tsb-v="color"]', box).textContent = rangeText(COLORS, F.color);
    $('[data-tsb-v="clarity"]', box).textContent = rangeText(CLARITY, F.clarity);
    $('[data-tsb-v="cut"]', box).textContent = rangeText(CUTS, F.cut);
    $('[data-tsb-v="polish"]', box).textContent = rangeText(FINISH, F.polish);
    $('[data-tsb-v="symmetry"]', box).textContent = rangeText(FINISH, F.symmetry);
    $('[data-tsb-v="ratio"]', box).textContent = F.ratio ? F.ratio.join(' to ') : 'Any';
    var n = activeCount(); $('[data-tsb-nfil]', box).textContent = n ? '(' + n + ')' : '';
    $$('[data-dtype]', box).forEach(function (b) { var on = b.dataset.dtype === F.type; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', String(on)); });
    var tn = $('[data-tsb-typenote]', root);
    if (tn) tn.textContent = EARRING ? 'We match every pair ourselves: two IGI certified lab grown diamonds with the same color, clarity and cut, within 0.05 ct and about 0.1 mm of each other. You see what they cost us before you choose.' : F.type === 'natural' ? 'Mined diamonds, GIA or IGI certified. You see what each one costs us before you choose.' : 'Grown above ground, IGI certified. You see what each one costs us before you choose.';
    var lt = $('[data-tsb-list-title]', root);
    if (lt) lt.textContent = EARRING ? 'Choose your matched pair' : NATURAL ? 'Choose your diamond' : 'Choose your lab grown diamond';
  }
  function body() {
    var round = oneShape() === 'round';
    var fl = []; F.fluor.forEach(function (k) { fl = fl.concat(FLUOR[k] || []); });
    return {
      color_from: COLORS[F.color[0]], color_to: COLORS[F.color[1]],
      clarity_from: CLARITY[F.clarity[0]], clarity_to: CLARITY[F.clarity[1]],
      cut_from: round ? CUTS[F.cut[0]] : 'Fair', cut_to: round ? CUTS[F.cut[1]] : 'Ideal',
      size_from: String(F.ctMin), size_to: String(F.ctMax),
      price_total_from: F.pMin === '' ? '0' : String(F.pMin), price_total_to: F.pMax === '' ? '1000000' : String(F.pMax),
      polish_from: FINISH[F.polish[0]], polish_to: FINISH[F.polish[1]], symmetry_from: FINISH[F.symmetry[0]], symmetry_to: FINISH[F.symmetry[1]],
      depth_percent_from: '1.00', depth_percent_to: '94.30', table_percent_from: '45.00', table_percent_to: '87.00',
      ratio_from: F.ratio ? F.ratio[0].toFixed(2) : '1.00', ratio_to: F.ratio ? F.ratio[1].toFixed(2) : '2.75', realView: false,
      fluorescence_intensities: fl.length ? fl : ['None'], labs: F.type === 'natural' ? ['GIA', 'IGI'] : ['IGI'],
      Shapes: F.shape.length ? F.shape : allowedShapes()
    };
  }
  var page = 1, ctrl = null, timer = null, pool = null;
  /* earrings: pull single diamonds (in the chosen sort order, 1,000 at a time) and pair them ourselves */
  function pairSearch(more) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController(); var sig = ctrl.signal;
    var grid = $('[data-tsb-grid]', root), btn = $('[data-tsb-loadmore]', root);
    var count = { set textContent(t) { $$('[data-tsb-count]', views.diamond).forEach(function (el) { el.textContent = t; }); } };
    var key = JSON.stringify(body()) + F.sort;
    try { sessionStorage.setItem(KEY_STATE + '_f', JSON.stringify(F)); } catch (e) {}
    if (!more || !pool || pool.key !== key) { pool = { key: key, pairs: [], left: [], used: {}, page: 0, total: Infinity, shown: 0 }; grid.innerHTML = skeleton(8); count.textContent = 'Matching pairs…'; }
    var need = pool.shown + 24, sort = F.sort.split('|'), rounds = 0;
    btn.hidden = true;
    function fill() {
      if (pool.pairs.length >= need || pool.page * 1000 >= pool.total || rounds >= 4) return Promise.resolve();
      pool.page++; rounds++;
      return api('?page=' + pool.page + '&limit=1000&sort_by=' + sort[0] + '&direction=' + sort[1], { method: 'POST', body: body(), signal: sig }, 'lab').then(function (r) {
        pool.total = (r.search && r.search.total) || 0;
        var list = (r.diamonds || []).map(normD).filter(notHidden); list.forEach(function (d) { d.type = 'lab'; });
        pool.left = pool.left.concat(list).filter(function (d) { return !pool.used[d.id]; });
        pool.pairs = sortPairs(pool.pairs.concat(matchPairs(pool.left, pool.used)), F.sort);
        pool.left = pool.left.filter(function (d) { return !pool.used[d.id]; });
        return fill();
      });
    }
    fill().then(function () {
      if (sig.aborted) return;
      var moreLeft = pool.page * 1000 < pool.total;
      pool.shown = Math.min(need, pool.pairs.length);
      var list = pool.pairs.slice(0, pool.shown);
      list.forEach(function (d) { cache['pair' + d.id] = d; });
      var n = pool.pairs.length;
      count.textContent = n.toLocaleString('en-US') + (moreLeft ? '+' : '') + ' matched pair' + (n === 1 ? '' : 's');
      grid.innerHTML = list.map(card).join('') || '<p class="tsb-none">No matched pairs for these filters yet. Try a wider carat, color or clarity range.</p>';
      btn.hidden = !(pool.pairs.length > pool.shown || moreLeft);
      // pairs with a diamond another shopper is checking out with: hide them
      heldElsewhere([].concat.apply([], list.map(stoneIdsOf))).then(function (held) {
        list.forEach(function (d) { if (stoneIdsOf(d).some(function (x) { return held[x]; })) { var c = grid.querySelector('[data-did="' + String(d.id).replace(/"/g, '') + '"]'); if (c) c.remove(); } });
      });
    }).catch(function (e) {
      if (e.name === 'AbortError') return;
      count.textContent = '';
      grid.innerHTML = '<p class="tsb-none">We could not load diamonds right now. Please try again in a moment.</p>';
    });
  }
  function search(more) {
    if (EARRING) return pairSearch(more);
    if (!more) page = 1;
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    var grid = $('[data-tsb-grid]', root), btn = $('[data-tsb-loadmore]', root);
    var count = { set textContent(t) { $$('[data-tsb-count]', views.diamond).forEach(function (el) { el.textContent = t; }); } };
    if (!more) { grid.innerHTML = skeleton(8); count.textContent = 'Searching…'; }
    btn.hidden = true;
    var sort = F.sort.split('|');
    try { sessionStorage.setItem(KEY_STATE + '_f', JSON.stringify(F)); } catch (e) {}
    api('?page=' + page + '&limit=24&sort_by=' + sort[0] + '&direction=' + sort[1], { method: 'POST', body: body(), signal: ctrl.signal }, F.type)
      .then(function (r) {
        var list = (r.diamonds || []).map(EARRING ? normPair : normD).filter(notHidden);
        list.forEach(function (d) { d.type = F.type; cache[F.type + d.id] = d; });
        var total = (r.search && r.search.total) || 0;
        count.textContent = total.toLocaleString('en-US') + (EARRING ? ' pair' : ' diamond') + (total === 1 ? '' : 's');
        var html = list.map(card).join('');
        if (more) grid.insertAdjacentHTML('beforeend', html); else grid.innerHTML = html || '<p class="tsb-none">No diamonds match these filters. Try a wider carat or color range.</p>';
        wireHearts(grid);
        btn.hidden = page * 24 >= total;
        heldElsewhere([].concat.apply([], list.map(stoneIdsOf))).then(function (held) {
          list.forEach(function (d) { if (stoneIdsOf(d).some(function (x) { return held[x]; })) { var c = grid.querySelector('[data-did="' + String(d.id).replace(/"/g, '') + '"]'); if (c) c.remove(); } });
        });
      })
      .catch(function (e) {
        if (e.name === 'AbortError') return;
        count.textContent = '';
        grid.innerHTML = '<p class="tsb-none">' + (F.type === 'natural' ? 'Natural diamonds are not available right now. Please see our lab grown diamonds, or try again later.' : 'We could not load diamonds right now. Please try again in a moment.') + '</p>';
      });
  }
  function skeleton(n) { var s = ''; for (var i = 0; i < n; i++) s += '<div class="tsb-card is-loading"><span class="tsb-card__img"></span><span class="tsb-sk"></span><span class="tsb-sk tsb-sk--s"></span></div>'; return s; }
  function shapeIcon(shape) { return 'https://cdn.shopify.com/s/files/1/0591/3663/9116/files/' + String(shape).toLowerCase() + '_diamond_shape.png'; }
  function dims(d) {
    var m = String(d.meas || '').split(/\s*[x×*]\s*/).map(parseFloat).filter(function (n) { return n > 0; });
    return m.length >= 2 ? m[0].toFixed(2) + ' × ' + m[1].toFixed(2) + ' mm' : '';
  }
  var dmap = {};
  function wireHearts(scope) { $$('[data-tsw-d]', scope).forEach(function (h) { if (!h._tsw && dmap[h.dataset.tswD]) wish(h, diamondItem(dmap[h.dataset.tswD])); }); }
  function card(d) {
    var vid = d.v360 ? '<button type="button" class="tsb-card__vid" data-vplay="' + esc(d.v360) + '" aria-label="Play video of this diamond"><svg width="10" height="10" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5v14l12-7z" fill="currentColor"/></svg><span>Video</span></button>' : '';
    var dm = dims(d), ratio = cap(d.shape) !== 'Round' && parseFloat(d.ratio) > 0 ? '<span class="tsb-card__ratio"> · ' + parseFloat(d.ratio).toFixed(2) + ' ratio</span>' : '';
    dmap[d.id] = d;
    return '<a class="tsb-card" href="' + dUrl(d) + '" data-did="' + d.id + '">' +
      '<button type="button" class="tsw-heart tsw-card" data-tsw-d="' + esc(d.id) + '" aria-label="Save to wishlist"></button>' +
      '<span class="tsb-card__img">' + (d.img ? '<img src="' + esc(d.img) + '" alt="' + esc(diamondTitle(d)) + '" loading="lazy" decoding="async" width="300" height="300" onerror="this.onerror=null;this.src=\'' + shapeIcon(d.shape) + '\';this.classList.add(\'is-icon\')">' : '<img class="is-icon" src="' + shapeIcon(d.shape) + '" alt="" width="80" height="80">') + '</span>' +
      '<span class="tsb-card__row"><span class="tsb-card__title">' + (d.pair ? ct(d.stones[0].carat) + ' + ' + ct(d.stones[1].carat) + ' ct ' + esc(cap(d.shape)) + ' pair' : ct(d.carat) + ' ct ' + esc(cap(d.shape))) + '</span>' + vid + '</span>' +
      '<span class="tsb-card__specs">' + esc(grades(d)) + '</span>' +
      (dm ? '<span class="tsb-card__dims">' + esc(dm) + ratio + '</span>' : '') +
      '<span class="tsb-card__foot"><span class="ts2-muted">' + esc(d.lab) + ' · ' + kindWord(d) + '</span><b>' + money(d.price) + '</b></span></a>';
  }
  /* video on the card: plays in place of the photo, without leaving the list */
  /* supplier 360 viewers (natural feed: loupe360, d360, diamdna...) are built for a 500 x 500 window: show them at that
     size and scale to fit their box, centred, instead of stretching (stretched, some draw too large and off-centre) */
  var VFRAME = 500, vfObs = window.ResizeObserver ? new ResizeObserver(function (es) { es.forEach(function (e) { fitFrame(e.target); }); }) : null;
  function fitFrame(box) {
    var w = box.clientWidth, h = box.clientHeight;
    $$('iframe.tsb-vframe', box).forEach(function (f) { if (f.parentElement === box && w && h) f.style.setProperty('--fs', String(Math.min(w, h) / VFRAME)); });
  }
  function fitFrames() {
    $$('iframe.tsb-vframe', root).forEach(function (f) {
      var box = f.parentElement; if (!box) return;
      if (vfObs && !box._tsbVf) { box._tsbVf = 1; vfObs.observe(box); }
      fitFrame(box);
    });
  }
  if (window.MutationObserver) new MutationObserver(function () { fitFrames(); }).observe(root, { childList: true, subtree: true });
  window.addEventListener('resize', fitFrames);
  function playCardVideo(btn) {
    var box = btn.closest('.tsb-card').querySelector('.tsb-card__img'), src = btn.getAttribute('data-vplay');
    if (box.querySelector('video,iframe')) { var m = box.querySelector('video,iframe'); m.remove(); box.classList.remove('is-playing'); btn.lastChild.textContent = 'Video'; btn.classList.remove('is-on'); return; }
    box.insertAdjacentHTML('beforeend', /\.mp4(\?|$)/i.test(src)
      ? '<video src="' + esc(src) + '" muted loop playsinline autoplay></video>'
      : '<iframe class="tsb-vframe" src="' + esc(src) + '" title="Diamond video" allowfullscreen></iframe>');
    box.classList.add('is-playing'); btn.lastChild.textContent = 'Photo'; btn.classList.add('is-on');
  }
  function bindFilters() {
    var box = $('[data-tsb-filters]', root);
    function later() { clearTimeout(timer); timer = setTimeout(function () { search(false); }, 350); }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-s]');
      if (b) {
        var s = b.dataset.s, i = F.shape.indexOf(s);
        if (i > -1) { if (F.shape.length > 1) F.shape.splice(i, 1); } else F.shape.push(s);
        if (!RATIOS[oneShape()]) F.ratio = null;
        drawFilters(); return later();
      }
      b = e.target.closest('[data-ct]');
      if (b) { var p = b.dataset.ct.split(','); F.ctMin = +p[0]; F.ctMax = +p[1]; drawFilters(); return later(); }
      b = e.target.closest('[data-g]');
      if (b) {
        var key = b.parentElement.getAttribute('data-f'), r = F[key], g = +b.dataset.g;
        // tap outside the range to widen it, tap an end to trim it, tap inside to move the nearer end
        if (g < r[0]) r[0] = g;
        else if (g > r[1]) r[1] = g;
        else if (r[0] < r[1]) {
          if (g === r[0]) r[0] = g + 1;
          else if (g === r[1]) r[1] = g - 1;
          else if (g - r[0] <= r[1] - g) r[0] = g; else r[1] = g;
        }
        drawFilters(); return later();
      }
      b = e.target.closest('[data-dtype]');
      if (b) { if (F.type !== b.dataset.dtype) { F.type = b.dataset.dtype; if (!EARRING) setPrefType(F.type); drawFilters(); search(false); } return; }
      b = e.target.closest('[data-fl]');
      if (b) { var k = b.dataset.fl, j = F.fluor.indexOf(k); if (j > -1) { if (F.fluor.length > 1) F.fluor.splice(j, 1); } else F.fluor.push(k); drawFilters(); return later(); }
      b = e.target.closest('[data-ra]');
      if (b) { F.ratio = b.dataset.ra ? b.dataset.ra.split(',').map(Number) : null; drawFilters(); return later(); }
      if (e.target.closest('[data-tsb-reset]')) { var keepShape = F.shape, keepSort = F.sort; F = defaults(); F.shape = keepShape; F.sort = keepSort; drawFilters(); return later(); }
      if (e.target.closest('[data-tsb-panel-open]')) { box.classList.toggle('is-open'); document.documentElement.classList.toggle('tsb-noscroll', box.classList.contains('is-open') && innerWidth < 990); return; }
      if (e.target.closest('[data-tsb-panel-close]')) { box.classList.remove('is-open'); document.documentElement.classList.remove('tsb-noscroll'); return; }
    });
    box.addEventListener('change', function (e) {
      var k = e.target.getAttribute('data-f'); if (!k) return;
      var v = e.target.value;
      if (k === 'ctMin' || k === 'ctMax') { F[k] = Math.max(0.2, parseFloat(v) || 0.2); if (F.ctMin > F.ctMax) { var t = F.ctMin; F.ctMin = F.ctMax; F.ctMax = t; } }
      else if (k === 'pMin' || k === 'pMax') F[k] = v === '' ? '' : Math.max(0, parseInt(v, 10) || 0);
      else F[k] = v;
      drawFilters(); search(false);
    });
    $('[data-tsb-loadmore]', root).addEventListener('click', function () { page++; search(true); });
    // pinned shape + carat
    var dbar = $('[data-tsb-dbar]', box), dpill = $('[data-tsb-dpill]', box), dsheet = $('[data-tsb-dsheet]', box), quick = $('.tsb-dtools', box);
    function hb() { var h = document.querySelector('sticky-header') || document.querySelector('header'); var b = h ? h.getBoundingClientRect().bottom : 0; return b > 0 ? b : 0; }
    var dTick = false;
    function dpin() {
      dTick = false;
      if (views.diamond.hidden) { dbar.classList.remove('is-on'); dpill.hidden = true; return; }
      var past = quick.getBoundingClientRect().bottom < hb() + 8;
      var end = $('[data-tsb-grid]', root).getBoundingClientRect().bottom < innerHeight * 0.6;
      var on = past && !end && !box.classList.contains('is-open');
      dbar.style.top = hb() + 'px'; dbar.classList.toggle('is-on', on); dbar.setAttribute('aria-hidden', String(!on));
      dpill.hidden = !on || !dsheet.hidden;
    }
    window.addEventListener('scroll', function () { if (!dTick) { dTick = true; setTimeout(dpin, 60); } }, { passive: true });
    dpill.addEventListener('click', function () { dsheet.hidden = false; dpill.hidden = true; document.documentElement.classList.add('tsb-noscroll'); });
    dsheet.addEventListener('click', function (e) {
      if (e.target === dsheet || e.target.closest('[data-tsb-dsheet-close]')) { dsheet.hidden = true; document.documentElement.classList.remove('tsb-noscroll'); dpin(); }
    });
    $('[data-tsb-grid]', root).addEventListener('click', function (e) {
      var vb = e.target.closest('[data-vplay]');
      if (vb) { e.preventDefault(); e.stopPropagation(); return playCardVideo(vb); }
      var a = e.target.closest('[data-did]'); if (!a || e.metaKey || e.ctrlKey) return;
      e.preventDefault(); history.pushState(null, '', a.href); route();
    });
  }
  function listView() {
    show('diamond'); renderSteps(2);
    if (!F) {
      try { F = JSON.parse(sessionStorage.getItem(KEY_STATE + '_f') || 'null'); } catch (e) { F = null; }
      var p = new URLSearchParams(location.search).get('shape');
      var pc = new URLSearchParams(location.search).get('ct');
      if (!F || (p && F.shape.join() !== cap(p)) || (pc && +pc !== F.ctMin)) F = defaults();
      fixF();
      // a link with dt=natural opens on natural diamonds (once natural is on, or in the ?ts2_natural=1 preview)
      if (NATURAL && !EARRING) { var dq = new URLSearchParams(location.search).get('dt'); F.type = dq === 'lab' || dq === 'natural' ? dq : prefType(); }
      // never search outside the setting's shapes
      var al = allowedShapes(); F.shape = F.shape.filter(function (s) { return al.indexOf(s) > -1; }); if (!F.shape.length) F.shape = [al[0]];
      var ts = $('[data-tsb-dtypes]', root); if (ts) ts.hidden = !NATURAL;
      drawFilters(); bindFilters(); search(false);
    }
  }

  /* ---------- one diamond ---------- */
  function stoneView(id, type) {
    type = EARRING ? 'pair' : type === 'natural' ? 'natural' : 'lab';
    show('stone'); renderSteps(2);
    var box = views.stone;
    box.innerHTML = '<div class="tsb-loading">Loading diamond…</div>';
    var ck = type + id;
    // the detail call carries the cost per carat (the list does not), so pairs always load it
    var own = EARRING && /^m\d+-\d+$/.test(String(id));
    // the detail call carries the certificate and cost per carat, so pairs always load both diamonds
    var got = own ? Promise.all(String(id).slice(1).split('-').map(function (one) { return api('/' + one, null, 'lab').then(function (x) { var d = normD(x); d.type = 'lab'; return d; }); }))
        .then(function (ab) { var d = pairOf(ab[0], ab[1]); cache[ck] = d; return d; })
      : cache[ck] && cache[ck].cert && !EARRING ? Promise.resolve(cache[ck]) : api('/' + id, null, type).then(function (x) { var d = EARRING ? normPair(x) : normD(x); d.type = type; cache[ck] = d; return d; });
    got.then(function (d) {
      if (d.pair) return pairView(d, box);
      var s = state.setting;
      var fits = !s || (allowedShapes().indexOf(cap(d.shape)) > -1);
      var facts = [['Carat', ct(d.carat)], ['Color', d.color], ['Clarity', d.clarity], ['Cut', d.cut && d.cut !== '-' ? d.cut : ''], ['Ratio', d.ratio], ['Size (mm)', d.meas]]
        .filter(function (f) { return f[1]; });
      var more = [['Polish', d.polish], ['Symmetry', d.symmetry], ['Fluorescence', d.fluor], ['Table', d.table ? d.table + '%' : ''], ['Depth', d.depth ? d.depth + '%' : ''], ['Laser inscription', d.inscription], ['Report', d.lab + (d.cert ? ' ' + d.cert : '')]]
        .filter(function (f) { return f[1] && f[1] !== '-'; });
      box.innerHTML =
        '<a class="tsb-back" href="' + bUrl({ step: 'diamond' }) + '" data-tsb-back>← All diamonds</a>' +
        '<div class="ts2-top">' +
          '<div class="ts2-gallery tsb-gal" data-tsb-sgallery><div class="tsb-gal__thumbs" data-tsb-thumbs></div><div class="ts2-gallery__main"><div class="ts2-gallery__track" data-tsb-track></div><div class="ts2-dots" data-tsb-dots></div></div></div>' +
          '<div class="ts2-buy tsb-buy">' +
            '<div class="tsb-eyebrow">' + esc(d.lab) + ' certified · ' + kindWord(d) + '</div>' +
            '<h1 class="tsb-title">' + esc(diamondTitle(d)) + '</h1>' +
            '<div class="tsb-price">' + money(d.price) + ' <span class="ts2-muted">diamond only</span></div>' +
            '<div class="tsb-facts4">' + facts.map(function (f) { return '<div><b>' + esc(f[1]) + '</b><span>' + esc(f[0]) + '</span></div>'; }).join('') + '</div>' +
            (fits ? '<div class="tsw-btnrow"><button type="button" class="tsb-btn" data-tsb-pick>' + (s ? 'Choose this diamond · Complete your ' + W.piece : 'Choose this diamond · Pick a ' + W.setting) + '</button>' +
                    '<button type="button" class="tsw-heart tsw-big" data-tsw-stone aria-label="Save to wishlist"></button></div>'
                  : '<p class="tsb-error">This shape does not fit the ' + esc(s.design) + ' setting. <a href="' + bUrl({ step: 'diamond' }) + '">See diamonds that fit</a>.</p>' +
                    '<div class="tsw-btnrow"><button type="button" class="tsw-heart tsw-big" data-tsw-stone aria-label="Save to wishlist"></button></div>') +
            (s && fits ? '<p class="ts2-muted ts2-small tsb-center">With the ' + esc(s.design) + ' setting: ' + money(s.price + d.price) + '</p>' : '') +
            '<details class="tsb-acc" open><summary>Diamond details</summary><div class="tsb-mini">' + more.map(function (f) { return '<div><span>' + esc(f[0]) + '</span><span>' + esc(f[1]) + '</span></div>'; }).join('') + '</div>' +
              (d.growth ? '<p class="ts2-muted ts2-small">' + esc(d.growth.replace(/\.(?=\S)/g, '. ')) + '</p>' : '') + '</details>' +
            (d.certUrl ? '<div class="tsb-onerep">' + reportCell(d, 0, diamondTitle(d)) + '</div>' : '') +
            pairManifest(d) +
          '</div>' +
        '</div>';
      wish($('[data-tsw-stone]', box), diamondItem(d));
      var repClick1 = bindReports(box, [d]);
      box.onclick = function (e) { repClick1(e); };
      var slides = [];
      if (d.img) slides.push({ src: d.img, alt: diamondTitle(d) });
      if (d.v360) slides.push({
        html: /\.mp4(\?|$)/i.test(d.v360) ? '<video src="' + esc(d.v360) + '" muted loop playsinline autoplay preload="metadata"></video>'
                                          : '<iframe class="tsb-vframe" src="' + esc(d.v360) + '" title="360° view" loading="lazy" allowfullscreen></iframe>',
        thumb: '<span class="tsb-360">Video</span>' });
      if (!slides.length) slides.push({ src: shapeIcon(d.shape), alt: '' });
      gallery($('[data-tsb-sgallery]', box), slides);
      // a Video / Photo switch on the big image (bottom right)
      if (d.v360 && slides.length > 1) {
        var gm = $('[data-tsb-sgallery] .ts2-gallery__main', box), tr = $('[data-tsb-track]', gm), vi = slides.length - 1;
        gm.insertAdjacentHTML('beforeend', '<button type="button" class="tsb-tool tsb-imgvid" data-tsb-imgvid><svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5v14l12-7z" fill="currentColor"/></svg><span>Video</span></button>');
        var vb = $('[data-tsb-imgvid]', gm);
        function sync() { var onVid = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)) === vi; vb.querySelector('span').textContent = onVid ? 'Photo' : 'Video'; vb.classList.toggle('is-on', onVid); }
        vb.addEventListener('click', function () {
          var onVid = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)) === vi;
          tr.scrollTo({ left: onVid ? 0 : tr.clientWidth * vi, behavior: 'auto' });
          setTimeout(sync, 50);
        });
        tr.addEventListener('scroll', function () { clearTimeout(vb._t); vb._t = setTimeout(sync, 80); });
      }
      var pick = $('[data-tsb-pick]', box);
      if (pick) pick.addEventListener('click', function () {
        state.diamond = d; save(state);
        if (state.setting) { history.pushState(null, '', bUrl({ step: 'complete' })); route(); }
        else location.href = SETTINGS_URL;
      });
      $('[data-tsb-back]', box).addEventListener('click', function (e) { e.preventDefault(); history.pushState(null, '', this.href); route(); });
    }).catch(function () {
      box.innerHTML = '<div class="tsb-empty"><h1 class="tsb-title">' + (EARRING ? 'A diamond in this pair was just sold' : 'This diamond is no longer available') + '</h1><a class="tsb-btn" href="' + bUrl({ step: 'diamond' }) + '">' + (EARRING ? 'See other pairs' : 'See other diamonds') + '</a></div>';
    });
  }

  function matchNote(a, b) {
    var ma = pmm(a), mb = pmm(b), dc = Math.abs(a.carat - b.carat), txt;
    if (ma.length >= 2 && mb.length >= 2) {
      var dm = cap(a.shape) === 'Round' ? Math.abs((ma[0] + ma[1]) / 2 - (mb[0] + mb[1]) / 2)
        : Math.max(Math.abs(Math.max(ma[0], ma[1]) - Math.max(mb[0], mb[1])), Math.abs(Math.min(ma[0], ma[1]) - Math.min(mb[0], mb[1])));
      txt = (dm < 0.005 ? 'the same size' : 'within ' + dm.toFixed(2) + ' mm') + ' and ' + (dc < 0.005 ? 'the same carat weight' : dc.toFixed(2) + ' ct') + ' of each other';
    }
    return '<p class="tsb-matchnote">Matched by us: same color, clarity' + (cap(a.shape) === 'Round' ? ', cut' : '') + ' and fluorescence' + (txt ? ', ' + txt : '') + '.</p>';
  }

  /* grading reports shown on our page: the supplier's PDF is read directly and drawn with PDF.js
     (loaded only when a report scrolls into view), with a full-screen view and a real download */
  var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/', pdfLib = null, pdfBuf = {};
  function loadPdfJs() {
    if (!pdfLib) pdfLib = new Promise(function (res, rej) {
      if (window.pdfjsLib) return res(window.pdfjsLib);
      var sc = document.createElement('script'); sc.src = PDFJS + 'pdf.min.js';
      sc.onload = function () { window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS + 'pdf.worker.min.js'; res(window.pdfjsLib); };
      sc.onerror = function () { pdfLib = null; rej(new Error('pdfjs')); }; document.head.appendChild(sc);
    });
    return pdfLib;
  }
  function reportBytes(url) {
    if (!pdfBuf[url]) pdfBuf[url] = fetch(url).then(function (r) { if (!r.ok) throw new Error('report ' + r.status); return r.arrayBuffer(); });
    return pdfBuf[url];
  }
  function drawReport(url, host, cssWidth) { // draws every page of the report into host, cssWidth wide
    return Promise.all([loadPdfJs(), reportBytes(url)]).then(function (r) { return r[0].getDocument({ data: r[1].slice(0) }).promise; }).then(function (pdf) {
      var jobs = [];
      for (var n = 1; n <= Math.min(pdf.numPages, 4); n++) jobs.push(pdf.getPage(n).then(function (pg) {
        var v1 = pg.getViewport({ scale: 1 }), dpr = Math.min(window.devicePixelRatio || 1, 2), vp = pg.getViewport({ scale: cssWidth / v1.width * dpr });
        var c = document.createElement('canvas'); c.width = Math.round(vp.width); c.height = Math.round(vp.height);
        return pg.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise.then(function () { return c; });
      }));
      return Promise.all(jobs).then(function (cs) { host.innerHTML = ''; cs.forEach(function (c) { host.appendChild(c); }); });
    });
  }
  function downloadReport(url, name) {
    reportBytes(url).then(function (buf) {
      var a = document.createElement('a'); a.href = URL.createObjectURL(new Blob([buf], { type: 'application/pdf' })); a.download = name + '.pdf';
      document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 4000);
    }).catch(function () { window.open(url, '_blank', 'noopener'); });
  }
  function openReport(url, title, name) {
    var m = document.createElement('div'); m.className = 'tsb-repmodal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-label', title);
    m.innerHTML = '<div class="tsb-repmodal__bar"><b>' + esc(title) + '</b><button type="button" data-rz>Zoom in</button><button type="button" data-rd>Download</button><button type="button" data-rc aria-label="Close">Close</button></div>' +
      '<div class="tsb-repmodal__pages"><div class="tsb-repmodal__in"><p class="tsb-loading">Loading report…</p></div></div>';
    document.body.appendChild(m); document.documentElement.style.overflow = 'hidden';
    var inner = $('.tsb-repmodal__in', m);
    drawReport(url, inner, Math.max(1100, Math.min(window.innerWidth, 1400))).catch(function () {
      inner.innerHTML = '<p class="tsb-loading">This report could not be shown here. <a href="' + esc(url) + '" target="_blank" rel="noopener">Open it on its own page</a>.</p>';
    });
    function close() { m.remove(); document.documentElement.style.overflow = ''; document.removeEventListener('keydown', key); }
    function key(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', key);
    m.addEventListener('click', function (e) {
      if (e.target.closest('[data-rc]') || e.target === m) return close();
      if (e.target.closest('[data-rd]')) return downloadReport(url, name);
      var z = e.target.closest('[data-rz]'); if (z) { var on = m.classList.toggle('is-zoom'); z.textContent = on ? 'Fit to screen' : 'Zoom in'; }
    });
  }

  function reportCell(x, i, label) {
    if (!x.certUrl) return '<span class="tsb-cmp__cert is-off"><b>' + esc(x.lab) + ' report</b><span>' + esc(x.cert || '–') + '</span></span>';
    return '<div class="tsb-rep" data-rep="' + i + '">' +
      '<button type="button" class="tsb-rep__thumb" data-repview aria-label="View the ' + esc(x.lab) + ' report' + (label ? ' for ' + esc(label) : '') + '"><span class="tsb-rep__ph">' + esc(x.lab) + ' report</span></button>' +
      '<div class="tsb-rep__cap"><b>' + esc(x.lab) + ' report</b><span>' + esc(x.cert) + '</span></div>' +
      '<div class="tsb-rep__btns"><button type="button" data-repview>View</button><button type="button" data-repdl>Download</button></div></div>';
  }
  function bindReports(box, list) { // previews drawn when they come into view; returns a click handler
    var reps = $$('.tsb-rep', box);
    function drawThumbs() { reps.forEach(function (r) { var x = list[+r.dataset.rep], th = $('.tsb-rep__thumb', r);
      drawReport(x.certUrl, th, th.clientWidth || 160).then(function () { r.classList.add('is-ready'); }).catch(function () { r.classList.add('is-failed'); }); }); }
    if (reps.length) {
      if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); drawThumbs(); } }, { rootMargin: '300px' }); io.observe(reps[0]); }
      else drawThumbs();
    }
    return function (e) {
      var rv = e.target.closest('[data-repview],[data-repdl]'); if (!rv) return false;
      var x = list[+rv.closest('.tsb-rep').dataset.rep], nm = x.lab + '-' + x.cert;
      if (rv.hasAttribute('data-repdl')) downloadReport(x.certUrl, nm); else openReport(x.certUrl, x.lab + ' report ' + x.cert, nm);
      return true;
    };
  }

  /* the pair's own Transparency Manifest: what each diamond costs us, what we make, your price */
  function pairManifest(d) {
    var st = d.pair ? d.stones : [d], cost = st.reduce(function (t, x) { return t + x.cost; }, 0), fee = d.price - cost, pct = d.price ? Math.round(fee * 100 / d.price) : 0;
    var crane = $('.ts2-mcard__crane', root);
    function line(x, n) {
      var perCt = x.carat ? Math.round(x.cost / x.carat) : 0;
      return '<details class="ts2-mcard__item"' + (d.pair ? '' : ' open') + '><summary class="ts2-mcard__row"><b>' + (d.pair ? 'Diamond ' + n : 'Diamond') + '</b><span>' + money2(x.cost) + '</span></summary>' +
        '<div class="ts2-mcard__body"><div class="ts2-mcard__subrow"><span>' + esc(ct(x.carat) + ' ct ' + cap(x.shape) + ', ' + grades(x) + ', ' + x.lab + (x.cert ? ' ' + x.cert : '')) + '</span><span></span></div>' +
        (perCt ? '<div class="ts2-mcard__subrow"><span>Our cost per carat</span><span>' + money2(perCt) + '</span></div>' : '') +
        (d.pair ? '<div class="ts2-mcard__subrow"><span>Your price for this diamond</span><span>' + money2(x.price) + '</span></div>' : '') + '</div></details>';
    }
    return '<div class="ts2-manifest tsb-manifest tsb-pairman"><div class="ts2-mcard">' +
      (crane ? '<img class="ts2-mcard__crane" src="' + esc(crane.getAttribute('src')) + '" alt="" width="64" height="147" loading="lazy">' : '') +
      '<div class="ts2-mcard__brand">True Sanity</div><div class="ts2-mcard__kind">Transparency Manifest</div><span class="ts2-mcard__dash" aria-hidden="true"></span>' +
      '<dl class="ts2-mcard__meta"><div><dt>Stock No.</dt><dd>' + esc(st.map(function (x) { return x.cert; }).filter(Boolean).join(' / ') || String(d.id)) + '</dd></div>' +
        '<div><dt>Item:</dt><dd>' + esc(diamondTitle(d)) + '</dd></div></dl>' +
      '<div class="ts2-mcard__lines"><div class="ts2-mcard__rows">' + st.map(function (x, i) { return line(x, i + 1); }).join('') + '</div>' +
        '<div class="ts2-mcard__rows ts2-mcard__rows--sum">' +
          '<div class="ts2-mcard__row"><b>Total Cost</b><span>' + money2(cost) + '</span></div>' +
          '<div class="ts2-mcard__row"><b>Protocol Fee <small>(what we make, ' + pct + '%)</small></b><span>' + money2(fee) + '</span></div>' +
        '</div>' +
        '<div class="ts2-mcard__price"><span>Your Price</span><span>' + money2(d.price) + '</span></div></div>' +
      '<p class="ts2-muted ts2-small tsb-pairman__note">' + (d.pair ? 'For the diamonds only. With your setting, the full manifest for your earrings is on the last step.'
        : 'For the diamond only. With your ' + W.setting + ', the full manifest for your ' + W.piece + ' is on the last step.') + '</p>' +
    '</div></div>';
  }

  /* one matched pair (earrings): both diamonds side by side */
  function pairView(d, box) {
    var s = state.setting, a = d.stones[0], b = d.stones[1], A = [a, b];
    var fits = !s || allowedShapes().indexOf(cap(d.shape)) > -1, round = cap(d.shape) === 'Round';
    var ma = pmm(a), mb = pmm(b);
    function same(x, y) { return String(x || '').toLowerCase() === String(y || '').toLowerCase(); }
    function apart(n, unit, dp) { return n < Math.pow(10, -dp) / 2 ? 'Same' : n.toFixed(dp) + unit + ' apart'; }
    function pct(x) { return x && x !== '-' ? parseFloat(x) + '%' : ''; }
    // each row: label, value for diamond 1, value for diamond 2, how they compare
    var rows = [
      ['Carat', ct(a.carat), ct(b.carat), apart(Math.abs(a.carat - b.carat), ' ct', 2)],
      ['Color', a.color, b.color, same(a.color, b.color) ? 'Same' : 'Different'],
      ['Clarity', a.clarity, b.clarity, same(a.clarity, b.clarity) ? 'Same' : 'Different'],
      ['Cut', a.cut && a.cut !== '-' ? a.cut : '', b.cut && b.cut !== '-' ? b.cut : '', same(a.cut, b.cut) ? 'Same' : 'Different'],
      ['Measurements (mm)', String(a.meas || '').replace(/\s*[x*]\s*/g, ' × '), String(b.meas || '').replace(/\s*[x*]\s*/g, ' × '),
        ma.length >= 2 && mb.length >= 2 ? (round ? apart(Math.abs((ma[0] + ma[1]) / 2 - (mb[0] + mb[1]) / 2), ' mm', 2)
          : apart(Math.max(Math.abs(Math.max(ma[0], ma[1]) - Math.max(mb[0], mb[1])), Math.abs(Math.min(ma[0], ma[1]) - Math.min(mb[0], mb[1]))), ' mm', 2)) : ''],
      ['Ratio', !round && a.ratio ? parseFloat(a.ratio).toFixed(2) : '', !round && b.ratio ? parseFloat(b.ratio).toFixed(2) : '', !round ? apart(Math.abs((parseFloat(a.ratio) || 0) - (parseFloat(b.ratio) || 0)), '', 2) : ''],
      ['Polish', a.polish, b.polish, same(a.polish, b.polish) ? 'Same' : 'Different'],
      ['Symmetry', a.symmetry, b.symmetry, same(a.symmetry, b.symmetry) ? 'Same' : 'Different'],
      ['Fluorescence', a.fluor, b.fluor, same(a.fluor, b.fluor) ? 'Same' : 'Different'],
      ['Table', pct(a.table), pct(b.table), apart(Math.abs((parseFloat(a.table) || 0) - (parseFloat(b.table) || 0)), '%', 1)],
      ['Depth', pct(a.depth), pct(b.depth), apart(Math.abs((parseFloat(a.depth) || 0) - (parseFloat(b.depth) || 0)), '%', 1)],
      ['Price', money(a.price), money(b.price), '']
    ].filter(function (r) { return (r[1] && r[1] !== '-') || (r[2] && r[2] !== '-'); });
    function cmpRow(r) {
      var tag = r[3] ? '<em class="' + (r[3] === 'Same' ? 'is-same' : r[3] === 'Different' ? 'is-diff' : '') + '">' + esc(r[3]) + '</em>' : '';
      return '<div class="tsb-cmp__row"><div class="tsb-cmp__k">' + esc(r[0]) + tag + '</div><div class="tsb-cmp__v">' + esc(r[1] || '–') + '</div><div class="tsb-cmp__v">' + esc(r[2] || '–') + '</div></div>';
    }
    var anyVid = A.some(function (x) { return x.v360; });
    box.innerHTML =
      '<a class="tsb-back" href="' + bUrl({ step: 'diamond' }) + '" data-tsb-back>← All pairs</a>' +
      '<div class="tsb-pairpg">' +
        '<div class="tsb-pairpg__head">' +
          '<div class="tsb-eyebrow">' + esc(d.lab) + ' certified · Matched lab grown pair</div>' +
          '<h1 class="tsb-title">' + esc(diamondTitle(d)) + '</h1>' +
          '<div class="tsb-price">' + money(d.price) + ' <span class="ts2-muted">for both diamonds</span></div>' +
          (d.own ? matchNote(a, b) : '') +
        '</div>' +
        '<div class="tsb-cmp">' +
          (anyVid ? '<div class="tsb-cmp__bar"><span>Side by side</span><button type="button" class="tsb-cmp__both" data-both="video">Play both videos</button></div>' : '') +
          '<div class="tsb-cmp__media">' + A.map(function (x, i) {
            return '<figure class="tsb-cmp__fig" data-n="' + i + '"><figcaption>Diamond ' + (i + 1) + ' <span>' + ct(x.carat) + ' ct</span></figcaption>' +
              '<div class="tsb-cmp__box" data-box></div>' +
              (x.v360 ? '<div class="tsb-cmp__tabs"><button type="button" data-show="photo" class="is-on">Photo</button><button type="button" data-show="video">Video</button></div>' : '') +
              '</figure>';
          }).join('') + '</div>' +
          '<div class="tsb-cmp__rows">' + rows.map(cmpRow).join('') + '</div>' +
          '<div class="tsb-cmp__certs">' + A.map(function (x, i) { return reportCell(x, i, 'diamond ' + (i + 1)); }).join('') + '</div>' +
        '</div>' +
        '<div class="tsb-pairpg__buy">' +
          (fits ? '<div class="tsw-btnrow"><button type="button" class="tsb-btn" data-tsb-pick>' + (s ? 'Choose this pair · Complete your earrings' : 'Choose this pair · Pick a setting') + '</button>' +
                  '<button type="button" class="tsw-heart tsw-big" data-tsw-stone aria-label="Save to wishlist"></button></div>'
                : '<p class="tsb-error">This shape does not fit the ' + esc(s.design) + ' setting. <a href="' + bUrl({ step: 'diamond' }) + '">See pairs that fit</a>.</p>') +
          (s && fits ? '<p class="ts2-muted ts2-small tsb-center">With the ' + esc(s.design) + ' setting: ' + money(s.price + d.price) + '</p>' : '') +
          pairManifest(d) +
        '</div>' +
      '</div>';
    // media: each diamond's photo, or its video; supplier photos are sometimes missing, so a missing photo falls back to the video
    function vidHtml(x, i) {
      return /\.mp4(\?|$)/i.test(x.v360) ? '<video src="' + esc(x.v360) + '" muted loop playsinline autoplay preload="metadata"></video>'
        : '<iframe class="tsb-vframe" src="' + esc(x.v360) + '" title="Diamond ' + (i + 1) + ' video" loading="lazy" allowfullscreen></iframe>';
    }
    function show(i, what) {
      var x = A[i], fig = $('.tsb-cmp__fig[data-n="' + i + '"]', box), bx = $('[data-box]', fig);
      if (what === 'photo' && !x.imgOk) what = x.v360 ? 'video' : 'icon';
      bx.innerHTML = what === 'video' ? vidHtml(x, i)
        : what === 'photo' ? '<img src="' + esc(x.img) + '" alt="Diamond ' + (i + 1) + ', ' + ct(x.carat) + ' ct ' + esc(cap(x.shape)) + '">'
        : '<img class="is-icon" src="' + shapeIcon(x.shape) + '" alt="">';
      $$('[data-show]', fig).forEach(function (t) { t.classList.toggle('is-on', t.dataset.show === what); });
    }
    Promise.all(A.map(function (x) { return x.img ? probeImg(x.img) : Promise.resolve(false); })).then(function (ok) {
      A.forEach(function (x, i) { x.imgOk = !!ok[i]; show(i, 'photo'); });
    });
    wish($('[data-tsw-stone]', box), diamondItem(d));
    var repClick = bindReports(box, A);
    box.onclick = function (e) {
      if (repClick(e)) return;
      var t = e.target.closest('[data-show]');
      if (t) { show(+t.closest('.tsb-cmp__fig').dataset.n, t.dataset.show); return; }
      var both = e.target.closest('[data-both]');
      if (both) {
        var w = both.dataset.both; A.forEach(function (x, i) { show(i, w); });
        both.dataset.both = w === 'video' ? 'photo' : 'video'; both.textContent = w === 'video' ? 'Show both photos' : 'Play both videos';
      }
    };
    var pick = $('[data-tsb-pick]', box);
    if (pick) pick.addEventListener('click', function () {
      state.diamond = d; save(state);
      if (state.setting) { history.pushState(null, '', bUrl({ step: 'complete' })); route(); }
      else location.href = SETTINGS_URL;
    });
    $('[data-tsb-back]', box).addEventListener('click', function (e) { e.preventDefault(); history.pushState(null, '', this.href); route(); });
  }

  /* ---------- step 3: complete ring ---------- */
  var setData = null, sizeSel = null;
  var ENTRY_SIZE = new URLSearchParams(location.search).get('size');   // ?size= from the bag, read before the URL is tidied
  function getSetting() {
    if (setData && setData.handle === state.setting.handle) return Promise.resolve(setData);
    return fetch('/products/' + state.setting.handle + '?view=ts2-dyor-data').then(function (r) { return r.json(); }).then(function (j) { setData = j; return j; });
  }
  function addBizDays(n) {
    var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }
  // a piece reopened from the wishlist: reload its diamond from the feed (live price, still for sale?)
  function freshDiamond(d) {
    if (d.own && /^m\d+-\d+$/.test(String(d.id))) {
      return Promise.all(String(d.id).slice(1).split('-').map(function (one) { return api('/' + one, null, 'lab').then(function (x) { if (!x || !(x.Diamond_ID || x.diamond_id)) throw new Error('sold'); var n = normD(x); n.type = 'lab'; return n; }); }))
        .then(function (ab) { return pairOf(ab[0], ab[1]); });
    }
    var type = d.pair ? 'pair' : isNat(d) ? 'natural' : 'lab';
    return api('/' + d.id, null, type).then(function (x) {
      if (!x || !(x.Diamond_ID || x.diamond_id || x.Diamond_ID2 || x.diamond_id2)) throw new Error('sold');
      var n = d.pair ? normPair(x) : normD(x); n.type = type; return n;
    });
  }
  function completeView() {
    var s = state.setting, d = state.diamond;
    if (!s) { show('nosetting'); renderSteps(1); return; }
    if (!d) { history.replaceState(null, '', bUrl({ step: 'diamond' })); return listView(); }
    if (new URLSearchParams(location.search).get('fresh') === '1') {
      history.replaceState(null, '', bUrl({ step: 'complete' }));
      show('complete'); renderSteps(3);
      $('[data-tsb-parts]', views.complete).innerHTML = '<div class="tsb-loading">Checking your diamond…</div>';
      freshDiamond(d).then(function (n) { state.diamond = n; save(state); completeView(); }, function () {
        delete state.diamond; save(state);
        history.replaceState(null, '', bUrl({ step: 'diamond', shape: cap(d.shape), ct: d.pair && d.stones ? d.stones[0].carat : d.carat }));
        listView();
        if (window.TSW) window.TSW.toast(EARRING ? 'A diamond in that pair has sold. Here are similar pairs.' : 'That diamond has sold. Here are similar diamonds.');
      });
      return;
    }
    show('complete'); renderSteps(3);
    var box = views.complete;
    Promise.all([getSetting(), imageList(s.pid)]).then(function (res) {
      var sd = res[0], list = res[1];
      var v = sd.variants.filter(function (x) { return x.id === s.vid; })[0] || sd.variants[0];
      s.price = v.price; s.cost = v.cost; s.metal = v.title; save(state);
      var shape = cap(d.shape);
      // ring photos at the carat closest to the diamond, ring video (or 360), diamond photo + video, ring box
      var sf = settingFiles(list, v.sku, shape, v.title, nearestToken(d.pair ? d.carat / 2 : d.carat));
      var bigCenter = !d.pair && d.carat > 4.5;
      var capEl = $('[data-tsb-c-shown]', box);
      if (capEl) { capEl.hidden = !bigCenter; capEl.textContent = bigCenter ? 'Ring shown with a 1 ct center. Yours is made for your ' + ct(d.carat) + ' ct diamond.' : ''; }
      var imgs = sf.photos, alt = 'The ' + sd.design + ', ' + shape + ', ' + v.title;
      var slides = imgs.slice(0, 1).map(function (u) { return { src: u, alt: alt }; });
      if (sf.video) slides.push({ html: '<video src="' + esc(sf.video) + '" muted loop playsinline autoplay preload="metadata"></video>', thumb: '<span class="tsb-360">' + W.Piece + '<br>video</span>' });
      else if (!EARRING) slides.push({ html: '<img class="tsb-autospin" alt="' + esc(alt) + ', 360° view" data-spin-base="https://dsv7iunirnrax.cloudfront.net/360/' + s.pid + '/' + String(v.sku).toLowerCase() + '_' + shape.toLowerCase() + '_' + sf.tk + '_' + sf.mk + '-4/frame" src="https://dsv7iunirnrax.cloudfront.net/360/' + s.pid + '/' + String(v.sku).toLowerCase() + '_' + shape.toLowerCase() + '_' + sf.tk + '_' + sf.mk + '-4/frame01.png">', thumb: '<span class="tsb-360">360°</span>' });
      if (d.pair) d.stones.forEach(function (x, i) { if (x.img && x.imgOk !== false) slides.push({ src: x.img, alt: 'Diamond ' + (i + 1), lazy: true }); });
      else if (d.img) slides.push({ src: d.img, alt: diamondTitle(d), lazy: true });
      if (d.pair) d.stones.forEach(function (x, i) { if (x.v360) slides.push(/\.mp4(\?|$)/i.test(x.v360)
        ? { html: '<video src="' + esc(x.v360) + '" muted loop playsinline autoplay preload="metadata"></video>', thumb: '<span class="tsb-360">Diamond ' + (i + 1) + '<br>video</span>' }
        : { html: '<iframe class="tsb-vframe" src="' + esc(x.v360) + '" title="Diamond ' + (i + 1) + ' video" loading="lazy" allowfullscreen></iframe>', thumb: '<span class="tsb-360">Diamond ' + (i + 1) + '<br>video</span>' }); });
      else if (d.v360) slides.push(/\.mp4(\?|$)/i.test(d.v360)
        ? { html: '<video src="' + esc(d.v360) + '" muted loop playsinline autoplay preload="metadata"></video>', thumb: '<span class="tsb-360">Diamond<br>video</span>' }
        : { html: '<iframe class="tsb-vframe" src="' + esc(d.v360) + '" title="Diamond 360° view" loading="lazy" allowfullscreen></iframe>', thumb: '<span class="tsb-360">Diamond<br>360°</span>' });
      // ring box right after the ring + diamond views (not buried after 7 ring photos), loaded eagerly
      var boxImg = root.getAttribute('data-ringbox');
      if (boxImg) slides.push({ src: boxImg, alt: 'True Sanity ' + (PENDANT || EARRING ? 'jewelry' : 'ring') + ' box' });
      imgs.slice(1).forEach(function (u) { slides.push({ src: u, alt: alt, lazy: true }); });
      gallery($('[data-tsb-cgallery]', box), slides.length ? slides : [{ src: sd.image, alt: sd.name }]);
      $$('.tsb-autospin', box).forEach(autoSpin);
      s.image = imgs[0] || sd.image;
      var total = v.price + d.price;
      var band = sd.isSet && sd.bridal && sd.bridal.bands && sd.bridal.bands[0];
      $('[data-tsb-c-title]', box).textContent = 'The ' + sd.design + (sd.isSet ? ' Bridal Set' : ' ' + W.Piece) + ' with a ' + diamondTitle(d);
      $('[data-tsb-c-price]', box).textContent = money(total);
      $('[data-tsb-parts]', box).innerHTML =
        part(s.image, sd.isSet ? 'Bridal set' : W.Setting, sd.design + (sd.isSet ? ' ring + ' + (band ? band.design + ' band' : 'matching band') : '') + ' · ' + v.title, money(v.price), SETTINGS_URL, s.link) +
        part(d.img || shapeIcon(d.shape), d.pair ? 'Diamonds' : 'Diamond', diamondTitle(d) + ' · ' + grades(d) + ' · ' + d.lab + (d.cert ? ' ' + d.cert : ''), money(d.price), bUrl({ step: 'diamond' }), dUrl(d));
      // sizes
      $('[data-tsb-sizerow]', box).hidden = EARRING;
      var sizes = String(sd.ringSizes || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      var sizeNote = $('[data-tsb-setsize]', box);
      if (!sizeNote) { $('[data-tsb-sizes]', box).insertAdjacentHTML('afterend', '<p class="ts2-muted ts2-small tsb-setsize" data-tsb-setsize hidden>Your engagement ring and band are both made in this size.</p>'); sizeNote = $('[data-tsb-setsize]', box); }
      sizeNote.hidden = !sd.isSet;
      // reopened from the bag (metal change): keep the size the shopper already chose
      if (!sizeSel && ENTRY_SIZE && sizes.indexOf(ENTRY_SIZE) > -1) sizeSel = ENTRY_SIZE;
      if (sizeSel && $('[data-tsb-size-cur]', box)) $('[data-tsb-size-cur]', box).textContent = sizeSel + (PENDANT ? ' inches' : '');
      $('[data-tsb-sizes]', box).innerHTML = sizes.map(function (z) { return '<button type="button" class="tsb-chip' + (z === sizeSel ? ' is-selected' : '') + '" data-size="' + z + '">' + z + (PENDANT ? '"' : '') + '</button>'; }).join('');
      // delivery: setting make time + diamond shipping time
      var ship = addBizDays((parseInt(v.shipDays, 10) || 10) + 7);
      $('[data-tsb-ship]', box).textContent = 'Made for you. Estimated delivery ' + ship + '.';
      box.setAttribute('data-ship', ship);
      // gift + manifest
      if (window.TS2Gift) window.TS2Gift.update(total, v.title);
      drawManifest(v, d, sd);
      $('[data-tsb-m-sku]', box).textContent = v.sku.toUpperCase() + ' + ' + d.lab + ' ' + (d.cert || d.id);
      wish($('[data-tsw-dyo]', box), function () {
        var t = 'The ' + sd.design + (sd.isSet ? ' Bridal Set' : ' ' + W.Piece) + ' with a ' + diamondTitle(d);
        return {
          key: 'd:' + KIND + ':' + s.vid + ':' + d.id, kind: 'dyo', build: KIND, title: t,
          sub: [v.title, grades(d), d.lab + (d.cert ? ' ' + d.cert : '')].filter(Boolean).join(' · '),
          image: s.image || d.img || '', price: v.price + d.price, make: lastMake || 0,
          url: bUrl({ step: 'complete' }), builder: BUILDER, settingsUrl: SETTINGS_URL, setting: state.setting, diamond: d
        };
      });
      $('[data-tsb-m-item]', box).textContent = sd.name + (sd.isSet ? ' (ring + band)' : '') + ', ' + ct(d.carat) + (d.pair ? ' ct t.w. ' + shape + ' lab diamond pair' : ' ct ' + shape + ' ' + (isNat(d) ? 'natural' : 'lab') + ' diamond');
    }).catch(function () {
      $('[data-tsb-parts]', box).innerHTML = '<p class="tsb-error">We could not load the setting. Please refresh the page.</p>';
    });
  }
  function part(img, label, text, price, changeHref, viewHref) {
    return '<div class="tsb-part"><a href="' + esc(viewHref) + '"><img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy"></a>' +
      '<a class="tsb-part__txt" href="' + esc(viewHref) + '"><span class="tsb-part__label">' + label + '</span><span>' + esc(text) + '</span></a>' +
      '<div class="tsb-part__end"><b>' + price + '</b><a href="' + esc(changeHref) + '">Change</a></div></div>';
  }
  var openLines = {}, lastMake = 0;
  function drawManifest(v, d, sd) {
    var c = v.cost, total = v.price + d.price;
    var lines = [
      { key: 'material', label: 'Material', cents: c.components, sub: sd.isSet ? v.title + ' engagement ring and matching band, with their side diamonds' : PENDANT ? v.title + ' pendant and chain' + (sd.sideCt ? ', side diamonds approx. ' + ct(sd.sideCt) + ' ct' : '') : v.title + ' setting with side diamonds' + (sd.sideCt ? ' (approx. ' + ct(sd.sideCt) + ' ct)' : '') },
      { key: 'diamond', label: d.pair ? 'Center Diamonds (pair)' : 'Center Diamond', cents: d.cost, sub: diamondTitle(d) + ', ' + grades(d) + ', ' + d.lab + (d.cert ? ' ' + d.cert : '') },
      { key: 'labor', label: 'Labor', cents: c.crafting + c.design, sub: 'Design, casting, setting and finishing' },
      { key: 'logistic', label: 'Logistics', cents: c.packaging + c.duties, sub: 'Packaging, duties, freight and shipping' }
    ].filter(function (l) { return l.cents > 0; });
    var g = window.TS2Gift && window.TS2Gift.selected ? window.TS2Gift.selected(total, v.title) : null;
    if (g && g.cost) lines.push({ key: 'gift', label: 'Free Gift', cents: g.cost, sub: g.title + ', ' + g.variant + '. Retail value ' + money(g.value) + ', free to you. Paid from what we make.' });
    var cost = lines.reduce(function (a, l) { return a + l.cents; }, 0);
    var fee = total - cost, pct = Math.round(fee * 100 / total);
    lastMake = pct;
    $('[data-tsb-manifest]', views.complete).innerHTML =
      '<div class="ts2-mcard__rows">' + lines.map(function (l) {
        return '<details class="ts2-mcard__item" data-key="' + l.key + '"' + (openLines[l.key] ? ' open' : '') + '><summary class="ts2-mcard__row"><b>' + l.label + '</b><span>' + money2(l.cents) + '</span></summary>' +
          '<div class="ts2-mcard__body"><div class="ts2-mcard__subrow"><span>' + esc(l.sub) + '</span><span></span></div></div></details>';
      }).join('') + '</div>' +
      '<div class="ts2-mcard__rows ts2-mcard__rows--sum">' +
        '<div class="ts2-mcard__row"><b>Total Cost</b><span>' + money2(cost) + '</span></div>' +
        '<div class="ts2-mcard__row"><b>Protocol Fee <small>(what we make, ' + pct + '%)</small></b><span>' + money2(fee) + '</span></div>' +
      '</div>' +
      '<div class="ts2-mcard__price"><span>Your Price</span><span>' + money2(total) + '</span></div>';
  }
  if (views.complete) {
    views.complete.addEventListener('toggle', function (e) { var k = e.target.getAttribute && e.target.getAttribute('data-key'); if (k) openLines[k] = e.target.open; }, true);
    views.complete.addEventListener('click', function (e) {
      var b = e.target.closest('[data-size]');
      if (b) {
        sizeSel = b.dataset.size;
        $$('[data-size]', views.complete).forEach(function (x) { x.classList.toggle('is-selected', x === b); });
        $('[data-tsb-size-cur]', views.complete).textContent = sizeSel + (PENDANT ? ' inches' : '');
        $('[data-tsb-size-error]', views.complete).hidden = true;
        return;
      }
      if (e.target.closest('[data-tsb-add]')) addToBag(e.target.closest('[data-tsb-add]'));
    });
    document.addEventListener('ts2:gift', function () {
      if (!setData || !state.setting || !state.diamond || views.complete.hidden) return;
      var v = setData.variants.filter(function (x) { return x.id === state.setting.vid; })[0];
      if (v) drawManifest(v, state.diamond, setData);
    });
  }

  function accentFor(sd, d) {
    // same rule as the old page: the carat key of the first setting size >= the diamond, else "1"
    var key = '1';
    for (var i = 0; i < (sd.sizes || []).length; i++) { if (d.carat <= parseFloat(sd.sizes[i].value)) { key = sd.sizes[i].key; break; } }
    var shape = cap(d.shape);
    var hit = (sd.accents || []).filter(function (a) { return a.carat === key && cap(a.shape) === shape; })[0] ||
      (sd.accents || []).filter(function (a) { return a.carat === '1' && cap(a.shape) === shape; })[0];
    return hit ? hit.html : '';
  }
  function addToBag(btn) {
    var s = state.setting, d = state.diamond, sd = setData, box = views.complete;
    var err = $('[data-tsb-add-error]', box); err.hidden = true;
    if (!sizeSel && !EARRING) {
      $('[data-tsb-size-error]', box).hidden = false;
      $('[data-tsb-sizerow]', box).scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!sd) return;
    var v = sd.variants.filter(function (x) { return x.id === s.vid; })[0] || sd.variants[0];
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding your ' + W.piece + '…';
    var ship = box.getAttribute('data-ship') || '';
    var settingImg = s.image || '';
    // legacy wizard info, so the cart, order emails and the team's order view read it like before
    var info = {
      setting_image_url: settingImg, setting_product_handle: sd.handle, setting_product_name: sd.title,
      setting_variant_id: v.id, setting_product_id: sd.pid, setting_variant_sku: v.sku, setting_variant_price: v.price,
      setting_min_carat_size: String(s.minCt), setting_max_carat_size: String(s.maxCt), setting_allowed_shapes: s.shapes,
      setting_selected_shape: cap(d.shape), setting_selected_carat_size: 1, setting_selected_metal: v.title,
      setting_selected_side_carat_weight: parseFloat(sd.sideCt) || 0, setting_allowed_ring_sizes: sd.ringSizes,
      setting_stone_type: 'Diamonds', setting_vendor: '', setting_delivery: '', setting_cad_no: '', setting_center_stone: '', setting_authenticity: '',
      setting_material_cost: (v.cost.components / 100).toFixed(2), setting_labor_cost: ((v.cost.crafting + v.cost.design) / 100).toFixed(2),
      setting_logistic_cost: ((v.cost.packaging + v.cost.duties) / 100).toFixed(2),
      page_type: 'new', stone_shape: cap(d.shape), stone_carat: String(d.carat), stone_price: d.price / 100, stone_id: d.id,
      stone_color: d.color, stone_cut: d.cut, stone_clarity: d.clarity, setting_side_carat_weight: String(d.carat),
      stone_image_url: d.img || shapeIcon(d.shape), stone_delivery: '7', vendor_name: d.seller,
      stone_certificate_no: d.cert, stone_certificate_type: d.lab, stone_vendor_name: d.seller, final_deliver: ship
    };
    if (d.pair) {
      var p1 = d.stones[0], p2 = d.stones[1];
      Object.assign(info, { stone_id: p2.id, stone_id1: p1.id, stone_carat: String(p2.carat), stone_carat1: String(p1.carat), stone_color: p2.color, stone_color1: p1.color,
        stone_clarity: p2.clarity, stone_clarity1: p1.clarity, stone_cut: p2.cut, stone_cut1: p1.cut, stone_price: p2.price / 100, stone_price1: p1.price / 100,
        stone_shape1: cap(p1.shape), stone_image_url: p2.img || shapeIcon(d.shape), stone_image_url1: p1.img || shapeIcon(d.shape),
        stone_certificate_no: p2.cert, stone_certificate_no1: p1.cert, stone_certificate_type1: p1.lab, stone_vendor_name: p2.seller, stone_vendor_name1: p1.seller });
    }
    try { localStorage.setItem(PENDANT ? 'wizardInfo_dyop' : EARRING ? 'wizardInfo_dyoe' : 'wizardInfo', JSON.stringify(info)); localStorage.setItem('wizardStart', '"StartWithSetting"'); } catch (e) {}
    if (d.own) return addOwnPair();
    /* our own matched pairs go in the bag as three linked lines: the earring setting (pair of settings,
       chosen metal) and the two diamonds, each priced on its own product. They share one _earring_bundle id;
       the cart keeps them together (ts2-cart-check). Uses only the calls the ring builder already makes. */
    function addOwnPair() {
      var bundle = 'E' + Date.now().toString(36).toUpperCase();
      info.pair_matched_by = 'TrueSanity'; info.earring_bundle = bundle;
      function diamondVariant(x) {
        return api('/' + x.id, null, 'lab').catch(function () { return null; }).then(function (r) {
          if (!r || !(r.Diamond_ID || r.diamond_id)) { var e = new Error('sold'); e.sold = true; throw e; }
          if (r.variant_id) return r;
          return api('/' + x.id, { method: 'POST' }, 'lab').then(function () { return api('/' + x.id, null, 'lab'); }).then(function (r2) {
            if (!r2 || !r2.variant_id) throw new Error('diamond product ' + x.id); return r2;
          });
        });
      }
      var a = d.stones[0], b = d.stones[1];
      // another shopper is checking out with one of these diamonds: don't sell it twice
      var heldP = heldElsewhere([a.id, b.id]).then(function (held) { if (held[a.id] || held[b.id]) { var he = new Error('held'); he.held = true; throw he; } });
      var pairText = ct(a.carat) + ' ct + ' + ct(b.carat) + ' ct ' + cap(d.shape) + ', ' + d.color + ', ' + d.clarity + (d.cut ? ', ' + d.cut : '') + ', ' + a.lab + ' ' + a.cert + ' / ' + b.cert;
      heldP.then(function () { return Promise.all([diamondVariant(a), diamondVariant(b)]); }).then(function (rs) {
        var setProps = {
          'Diamonds': pairText, 'Matched by': 'TrueSanity',
          '_earring_bundle': bundle, '_earring_product': true, '_pair_own': true, '_earring_part': 'setting',
          '_wizardInfo': JSON.stringify(JSON.stringify(info)), '_wizardStart': '"StartWithSetting"',
          '_pdid': sd.pid, '_pid': v.id, '_selectVariantPrice': v.price, '_image': settingImg, '_pname': sd.title,
          '_stoneShape': cap(d.shape), '_diamond_type_new': 'Lab Grown', '_deliver_date': ship, '_stoneDelivery': ship,
          '_certificate_type': b.lab, '_certificate_number': b.cert, '_certificate_type1': a.lab, '_certificate_number1': a.cert
        };
        function stoneProps(x, n) {
          return { 'For': 'The ' + sd.design + ' earrings (' + v.title + ')', 'Diamond': n + ' of 2', 'Certificate': x.lab + ' ' + x.cert,
            '_earring_bundle': bundle, '_earring_part': 'diamond' + n, '_stone_id': x.id };
        }
        var items = [{ id: parseInt(v.id, 10), quantity: 1, properties: setProps },
          { id: parseInt(rs[0].variant_id, 10), quantity: 1, properties: stoneProps(a, 1) },
          { id: parseInt(rs[1].variant_id, 10), quantity: 1, properties: stoneProps(b, 2) }];
        var giftP = window.TS2Gift ? window.TS2Gift.prepareAdd() : Promise.resolve(null);
        return giftP.then(function (gift) {
          if (gift) items.push(gift);
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
        });
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'cart'); });
        return r.json();
      }).then(function (j) {
        // the three lines must add up to the price on the page; if not, take them back out
        var mine = (j.items || []).filter(function (it) { return it.properties && it.properties._earring_bundle === bundle; });
        var sum = mine.reduce(function (t, it) { return t + it.original_line_price; }, 0);
        if (mine.length !== 3 || Math.abs(sum - (v.price + d.price)) > 300) {
          var updates = {}; mine.forEach(function (it) { updates[it.key] = 0; });
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
            .then(function () { var pe = new Error('price ' + sum + ' vs ' + (v.price + d.price)); pe.price = true; throw pe; });
        }
        delete state.diamond; save(state);
        var old = null, oldBundle = null;
        try { old = sessionStorage.getItem('ts2ReplaceLine'); oldBundle = sessionStorage.getItem('ts2ReplaceBundle'); ['ts2ReplaceLine', 'ts2ReplaceVariant', 'ts2ReplaceBundle'].forEach(function (k) { sessionStorage.removeItem(k); }); } catch (e) {}
        var done = function () { location.href = '/cart'; };
        if (!old && !oldBundle) return done();
        // a replacement for a pair from the bag (sold diamond or new metal): take the old bundle's lines out.
        // Shopify can re-key lines, so the bundle id (kept by the bag) is the reliable handle.
        return fetch('/cart.js').then(function (x) { return x.json(); }).then(function (c) {
          var oldB = oldBundle || ((c.items.filter(function (it) { return it.key === old; })[0] || {}).properties || {})._earring_bundle;
          var upd = {}; c.items.forEach(function (it) { if (it.key === old || (oldB && oldB !== bundle && it.properties && it.properties._earring_bundle === oldB)) upd[it.key] = 0; });
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: upd }) });
        }).then(done, done);
      }).catch(function (e) {
        btn.disabled = false; btn.textContent = label;
        err.innerHTML = e && e.held
          ? 'Another shopper is checking out with a diamond in this pair right now. It is held for them for up to 30 minutes. <a href="' + bUrl({ step: 'diamond', shape: cap(d.shape), ct: d.stones[0].carat }) + '">See similar pairs</a>'
          : e && e.sold
          ? 'Sorry, a diamond in this pair was just sold. Diamonds sell fast. <a href="' + bUrl({ step: 'diamond', shape: cap(d.shape), ct: d.stones[0].carat }) + '">See similar pairs</a>'
          : 'We could not add your earrings just now. Please try again, or contact us and we will place the order for you.';
        if (e && e.sold) { delete state.diamond; save(state); }
        err.hidden = false;
        if (window.console) console.error('Earring builder add to bag:', e);
      });
    }
    var dt = d.pair ? 'pair' : isNat(d) ? 'natural' : 'lab';
    heldElsewhere([d.id, d.id1]).then(function (held) {
      if (held[d.id] || (d.id1 && held[d.id1])) { var he = new Error('held'); he.held = true; throw he; }
      // the feed answers 404 once a diamond is sold: say so, don't show a generic error
      return api('/' + d.id, null, dt).catch(function (e) { if (/ 404$/.test(e && e.message)) return null; throw e; });
    })
      .then(function (x) {
        // sold elsewhere since the customer picked it (the feed is shared with other sites)
        if (!x || !(x.Diamond_ID || x.diamond_id || x.Diamond_ID2 || x.diamond_id2)) { var e = new Error('sold'); e.sold = true; throw e; }
        if (x.shopify_product_id == null) return api('/' + d.id, { method: 'POST' }, dt);
      })
      .then(function () {
        if (d.pair) return api('/ring', { method: 'POST', body: { diamond_id: d.id, diamond_id1: d.id1, variant_id: v.id, product_image: settingImg } }, dt);
        return api('/ring', { method: 'POST', body: { diamond_id: d.id, variant_id: v.id, product_image: settingImg, cad_no: '', center_stone: '', accent_stone_val: accentFor(sd, d) } }, dt);
      })
      .then(function (product) {
        var vid = product && product.variants && product.variants[0] && product.variants[0].id;
        if (!vid) throw new Error('ring');
        // never put a piece in the bag at a price that differs from the page (guards against a wrong build)
        var built = product.variants[0].price != null ? Math.round(parseFloat(product.variants[0].price) * 100) : null;
        if (EARRING && built != null && !isNaN(built) && Math.abs(built - (v.price + d.price)) > 200) { var pe = new Error('price ' + built + ' vs ' + (v.price + d.price)); pe.price = true; throw pe; }
        var props = {
          '_wizardInfo': JSON.stringify(JSON.stringify(info)), '_wizardStart': '"StartWithSetting"', '_allowedSize': sd.ringSizes,
          '_pdid': sd.pid, '_pid': v.id, '_selectVariantPrice': v.price, '_image': settingImg, '_pname': sd.title,
          '_stoneClarity': d.clarity, '_stoneColor': d.color, '_stoneCut': d.cut, '_stoneCarat': String(d.carat),
          '_stoneDelivery': ship, '_deliver_date': ship, '_stoneImage': d.img || shapeIcon(d.shape), '_stonePrice': d.price / 100,
          '_stoneShape': cap(d.shape), '_diamond_type_new': isNat(d) ? 'Natural' : 'Lab Grown', '_carat_list': '1|1,', '_vendor_name': d.seller,
          '_certificate_type': d.lab, '_certificate_number': d.cert,
          // read by the after-order stone check (Shopify Flow); kept apart from _wizardInfo, which a Flow strips from orders
          '_stone_id': String(d.id), '_stone_kind': dt
        };
        if (sd.isSet) {
          // the set price already covers the band: it rides on the ring line, made in the same metal and size
          var b = sd.bridal && sd.bridal.bands && sd.bridal.bands[0];
          var bv = b ? (b.variants.filter(function (x) { return x.title === v.title + ' / ' + sizeSel; })[0] || b.variants.filter(function (x) { return x.title.indexOf(v.title) === 0; })[0]) : null;
          props['Includes'] = 'Matching band' + (b ? ' (The ' + b.design + ')' : '') + ', ' + v.title + ', size ' + sizeSel;
          props['_bridal_set'] = sd.handle;
          if (bv) props['_band_variant_id'] = bv.id;
          if (b) props['_band_handle'] = b.url.split('/').pop();
        }
        // same line notes as the old pages: necklaces carry Chain_Length + _necklace_product, rings carry Size
        if (d.pair) {
          // same notes as the old earring pages: diamond 2 in the plain fields, diamond 1 in the "1" fields
          var q1 = d.stones[0], q2 = d.stones[1];
          Object.assign(props, { '_earring_product': true, '_stoneClarity': q2.clarity, '_stoneColor': q2.color, '_stoneCut': q2.cut, '_stoneCarat': String(q2.carat),
            '_stoneImage': q2.img || shapeIcon(d.shape), '_stonePrice': q2.price / 100, '_certificate_number': q2.cert, '_vendor_name': q2.seller,
            '_stoneClarity1': q1.clarity, '_stoneColor1': q1.color, '_stoneCut1': q1.cut, '_stoneCarat1': String(q1.carat), '_stoneImage1': q1.img || shapeIcon(d.shape),
            '_stonePrice1': q1.price / 100, '_stoneShape1': cap(q1.shape), '_vendor_name1': q1.seller, '_certificate_type1': q1.lab, '_certificate_number1': q1.cert });
          delete props['_allowedSize'];
        }
        else if (PENDANT) { props = Object.assign({ 'Chain_Length': sizeSel, '_necklace_product': true }, props); }
        else { props = Object.assign({ 'Size': sizeSel }, props); }
        var items = [{ id: parseInt(vid, 10), quantity: 1, properties: props }];
        var giftP = window.TS2Gift ? window.TS2Gift.prepareAdd() : Promise.resolve(null);
        return giftP.then(function (gift) {
          if (gift) items.push(gift);
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'cart'); });
        delete state.diamond; save(state);
        // this ring replaces one whose diamond sold while it sat in the bag: take the old line out
        var old = null, oldV = null; try { old = sessionStorage.getItem('ts2ReplaceLine'); oldV = sessionStorage.getItem('ts2ReplaceVariant'); sessionStorage.removeItem('ts2ReplaceLine'); sessionStorage.removeItem('ts2ReplaceVariant'); } catch (e) {}
        var done = function () { location.href = '/cart'; };
        if (!old && !oldV) return done();
        // Shopify can re-key bag lines, so find the old ring by its key, else by its own (one-off) ring variant, and remove it by position
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); }).then(function (c) {
          var idx = -1;
          c.items.forEach(function (it, n) { if (idx < 0 && it.key === old) idx = n; });
          if (idx < 0 && oldV) c.items.forEach(function (it, n) { if (idx < 0 && String(it.variant_id) === String(oldV)) idx = n; });
          if (idx < 0) return;
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: idx + 1, quantity: 0 }) });
        }).then(done, done);
      })
      .catch(function (e) {
        btn.disabled = false; btn.textContent = label;
        err.innerHTML = e && e.held
          ? 'Another shopper is checking out with this ' + (d.pair ? 'pair' : 'diamond') + ' right now. It is held for them for up to 30 minutes. <a href="' + bUrl({ step: 'diamond', shape: cap(d.shape), ct: d.pair && d.stones ? d.stones[0].carat : d.carat }) + '">See similar ' + (d.pair ? 'pairs' : 'diamonds') + '</a>'
          : e && e.sold
          ? (d.pair ? 'Sorry, a diamond in this pair was just sold. Diamonds sell fast. <a href="' + bUrl({ step: 'diamond', shape: cap(d.shape), ct: d.stones[0].carat }) + '">See similar pairs</a>'
            : 'Sorry, this diamond was just sold. Diamonds sell fast. <a href="' + bUrl({ step: 'diamond', shape: cap(d.shape), ct: d.carat }) + '">See similar diamonds</a>')
          : 'We could not add your ' + W.piece + ' just now. Please try again, or contact us and we will place the order for you.';
        if (e && e.sold) { delete state.diamond; save(state); }
        err.hidden = false;
        if (window.console) console.error('Ring builder add to bag:', e);
      });
  }

  /* ---------- routing ---------- */
  function route() {
    var p = new URLSearchParams(location.search);
    if (p.get('did')) return stoneView(p.get('did'), p.get('dt'));
    if (p.get('step') === 'complete') return completeView();
    listView();
  }
  window.addEventListener('popstate', route);
  route();
})();
